import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import * as Types from '../@types/index';
const defaultOptions = {} as const;
export type LoginMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.LoginInput>;
}>;

export type LoginMutation = {
  __typename?: 'Mutation';
  Login?: {
    __typename?: 'LoginResponse';
    status: boolean;
    message: string;
    TokenResponse?: {
      __typename?: 'TokenResponse';
      token?: string | null;
      token_type?: string | null;
    } | null;
  } | null;
};

export type SecureLoginMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.SecureLoginInput>;
}>;

export type SecureLoginMutation = {
  __typename?: 'Mutation';
  SecureLogin?: {
    __typename?: 'LoginResponse';
    status: boolean;
    message: string;
    TokenResponse?: {
      __typename?: 'TokenResponse';
      token?: string | null;
      token_type?: string | null;
    } | null;
  } | null;
};

export type RequestOtpMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.UserOtpInput>;
}>;

export type RequestOtpMutation = {
  __typename?: 'Mutation';
  RequestOTP?: {
    __typename?: 'OTPResponse';
    status: boolean;
    message?: string | null;
  } | null;
};

export type RegisterMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.RegisterInput>;
}>;

export type RegisterMutation = {
  __typename?: 'Mutation';
  Register?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type ResetPasswordSendEmailMutationVariables = Types.Exact<{
  user_email: Types.Scalars['String'];
}>;

export type ResetPasswordSendEmailMutation = {
  __typename?: 'Mutation';
  ResetPasswordSendEmail?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type ResetPasswordCheckMutationVariables = Types.Exact<{
  token?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type ResetPasswordCheckMutation = {
  __typename?: 'Mutation';
  ResetPasswordCheck?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type ResetPasswordMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ResetPasswordInput>;
}>;

export type ResetPasswordMutation = {
  __typename?: 'Mutation';
  ResetPassword?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type LogoutMutationVariables = Types.Exact<{ [key: string]: never }>;

export type LogoutMutation = {
  __typename?: 'Mutation';
  Logout?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type QuestionListingQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.QuestionListingInput>;
}>;

export type QuestionListingQuery = {
  __typename?: 'Query';
  QuestionListing?: {
    __typename?: 'QuestionPaginator';
    data: Array<{
      __typename?: 'Question';
      question_id: number;
      question_title?: string | null;
      question_value?: any | null;
      question_priority?: number | null;
      question_section?: number | null;
      question_status?: Types.QuestionStatus | null;
      question_type?: string | null;
      question_value_column?: number | null;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
  } | null;
};

export type DashboardOverviewQueryVariables = Types.Exact<{
  year?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type DashboardOverviewQuery = {
  __typename?: 'Query';
  DashboardMerchant?: {
    __typename?: 'DashboardMerchantStatus';
    status?: boolean | null;
    message?: string | null;
    data?: {
      __typename?: 'DashboardMerchantData';
      payment_overview?: Array<{
        __typename?: 'PaymentOverviewData';
        payment_status_name?: string | null;
        total_amount?: number | null;
      } | null> | null;
    } | null;
  } | null;
};

export type DashboardSpendingQueryVariables = Types.Exact<{
  year?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type DashboardSpendingQuery = {
  __typename?: 'Query';
  DashboardMerchant?: {
    __typename?: 'DashboardMerchantStatus';
    status?: boolean | null;
    message?: string | null;
    data?: {
      __typename?: 'DashboardMerchantData';
      spending_allocation?: {
        __typename?: 'SpendingAllocation';
        title?: string | null;
        data?: Array<{
          __typename?: 'SpendingAllocationData';
          payment_type_name?: string | null;
          amount?: number | null;
          count?: number | null;
          weightage?: number | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type DashboardUpcomingRecurringQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type DashboardUpcomingRecurringQuery = {
  __typename?: 'Query';
  DashboardMerchant?: {
    __typename?: 'DashboardMerchantStatus';
    status?: boolean | null;
    message?: string | null;
    data?: {
      __typename?: 'DashboardMerchantData';
      upcoming_recurring_payment?: Array<{
        __typename?: 'PaymentSchedule';
        payment_schedule_id?: number | null;
        payment_schedule_number?: number | null;
        payment_schedule_date?: any | null;
        payment_schedule_amount?: number | null;
        payment?: {
          __typename?: 'Payment';
          payment_schedule_total_number?: number | null;
          payment_recipient?: Array<{
            __typename?: 'PaymentRecipientDetails';
            payment_recipient_account_name?: string | null;
          } | null> | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type DashboardPaymentListingQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type DashboardPaymentListingQuery = {
  __typename?: 'Query';
  DashboardMerchant?: {
    __typename?: 'DashboardMerchantStatus';
    status?: boolean | null;
    message?: string | null;
    data?: {
      __typename?: 'DashboardMerchantData';
      payment_listing?: {
        __typename?: 'PaymentPaginator';
        paginatorInfo: {
          __typename?: 'PaginatorInfo';
          count: number;
          currentPage: number;
          firstItem?: number | null;
          hasMorePages: boolean;
          lastItem?: number | null;
          lastPage: number;
          perPage: number;
          total: number;
        };
        data: Array<{
          __typename?: 'Payment';
          payment_id?: number | null;
          payment_referer_code?: string | null;
          payment_end_date?: any | null;
          payment_recipient?: Array<{
            __typename?: 'PaymentRecipientDetails';
            payment_recipient_account_name?: string | null;
            payment_recipient_id?: number | null;
          } | null> | null;
          payment_status?: {
            __typename?: 'PaymentStatus';
            payment_status_name?: string | null;
          } | null;
        }>;
      } | null;
    } | null;
  } | null;
};

export type MeQueryVariables = Types.Exact<{ [key: string]: never }>;

export type MeQuery = {
  __typename?: 'Query';
  Me?: {
    __typename?: 'User';
    user_id?: number | null;
    username?: string | null;
    user_email?: string | null;
    user_alternative_email?: string | null;
    user_fullname?: string | null;
    user_nric?: string | null;
    user_gender?: Types.UserGender | null;
    user_address?: string | null;
    user_address2?: string | null;
    user_postcode?: string | null;
    user_dob?: any | null;
    user_status?: Types.UserStatus | null;
    user_logindate?: any | null;
    user_ip?: string | null;
    is_deleted?: boolean | null;
    user_mobile?: string | null;
    user_alternative_mobile?: string | null;
    user_mobile_verified?: boolean | null;
    user_join_date?: any | null;
    email_verified_at?: any | null;
    user_code?: string | null;
    user_created?: any | null;
    user_updated?: any | null;
    user_language?: string | null;
    user_nationality?: {
      __typename?: 'Country';
      country_code?: string | null;
      country_currency_code?: string | null;
      country_id?: number | null;
      country_international_code?: string | null;
      country_name?: string | null;
      is_deleted?: number | null;
    } | null;
    user_city?: {
      __typename?: 'City';
      city_id: number;
      city_name: string;
      is_deleted?: number | null;
    } | null;
    user_state?: {
      __typename?: 'State';
      is_deleted?: number | null;
      state_id?: number | null;
      state_name?: string | null;
    } | null;
    user_type?: {
      __typename?: 'UserType';
      user_type_id: number;
      user_type_name: string;
      user_type_slug: string;
      user_type_group?: string | null;
    } | null;
    user_role?: {
      __typename?: 'Role';
      id?: number | null;
      name?: string | null;
    } | null;
    user_permissions?: Array<{
      __typename?: 'Permission';
      id?: number | null;
      name?: string | null;
      group_name?: string | null;
      display_name?: string | null;
    } | null> | null;
    user_profile_image?: {
      __typename?: 'Images';
      media_id?: number | null;
      full?: string | null;
      thumb?: string | null;
    } | null;
    customer?: {
      __typename?: 'Customer';
      customer_id?: number | null;
      customer_registration_number?: string | null;
      customer_type?: Types.CustomerType | null;
      customer_name?: string | null;
      customer_website?: string | null;
      customer_address?: string | null;
      customer_postcode?: string | null;
      customer_address2?: string | null;
      customer_mobile?: string | null;
      customer_fax?: string | null;
      customer_email?: string | null;
      reject_reason_remark?: string | null;
      customer_contact_person?: string | null;
      customer_contact_person_mobile?: string | null;
      customer_status?: Types.CustomerStatus | null;
      customer_remark?: string | null;
      customer_created?: any | null;
      customer_updated?: any | null;
      is_deleted?: boolean | null;
      customer_bank_account_name?: string | null;
      customer_bank_account_number?: string | null;
      city?: { __typename?: 'City'; city_id: number; city_name: string } | null;
      state?: {
        __typename?: 'State';
        state_id?: number | null;
        state_name?: string | null;
      } | null;
      country?: {
        __typename?: 'Country';
        country_id?: number | null;
        country_name?: string | null;
      } | null;
      setting_annual_revenue?: {
        __typename?: 'AnnualRevenue';
        setting_annual_revenue_id?: number | null;
        setting_annual_revenue_name?: string | null;
      } | null;
      setting_company_size?: {
        __typename?: 'CompanySize';
        setting_company_size_id?: number | null;
        setting_company_size_name?: string | null;
      } | null;
      customer_question?: Array<{
        __typename?: 'CustomerQuestion';
        customer_question_id?: number | null;
        customer_question_title?: string | null;
        customer_question_value?: any | null;
        customer_question_created?: any | null;
        question?: {
          __typename?: 'Question';
          question_title?: string | null;
          question_value?: any | null;
          question_id: number;
        } | null;
      } | null> | null;
      ssm_business_certificate?: Array<{
        __typename?: 'Media';
        id?: number | null;
        url?: string | null;
        full_url?: string | null;
        file_name?: string | null;
        mime_type?: string | null;
      } | null> | null;
      reject_reason?: {
        __typename?: 'RejectReason';
        reject_reason_name?: string | null;
        reject_reason_id?: number | null;
      } | null;
      business_year?: {
        __typename?: 'BusinessYear';
        year_of_business_id?: number | null;
        year_of_business_name?: any | null;
      } | null;
      business_type?: {
        __typename?: 'BusinessType';
        business_type_id?: number | null;
        business_type_name?: any | null;
      } | null;
      bank?: {
        __typename?: 'Bank';
        bank_id?: number | null;
        bank_name?: string | null;
      } | null;
    } | null;
  } | null;
};

export type UserUpdateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.UserUpdateInput>;
}>;

export type UserUpdateMutation = {
  __typename?: 'Mutation';
  UserUpdate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type UserUpdatePasswordMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.UserUpdatePasswordInput>;
}>;

export type UserUpdatePasswordMutation = {
  __typename?: 'Mutation';
  UserUpdatePassword: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  };
};

export type CustomerUpdateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.CustomerUpdateInput>;
}>;

export type CustomerUpdateMutation = {
  __typename?: 'Mutation';
  CustomerUpdate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type SettingDetailsQueryVariables = Types.Exact<{
  input: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;

export type SettingDetailsQuery = {
  __typename?: 'Query';
  SettingDetails?: any | null;
};

export type SettingDetailQueryVariables = Types.Exact<{
  input: Types.Scalars['String'];
}>;

export type SettingDetailQuery = {
  __typename?: 'Query';
  SettingDetail?: {
    __typename?: 'Setting';
    setting_id?: number | null;
    setting_value?: string | null;
    setting_media?: { __typename?: 'Media'; url?: string | null } | null;
  } | null;
};

export type CustomerProfileUpdateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.CustomerProfileUpdateInput>;
}>;

export type CustomerProfileUpdateMutation = {
  __typename?: 'Mutation';
  CustomerProfileUpdate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type CustomerCreateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.CustomerCreateInput>;
}>;

export type CustomerCreateMutation = {
  __typename?: 'Mutation';
  CustomerCreate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type CustomerBankAccountUpdateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.CustomerBankAccountUpdateInput>;
}>;

export type CustomerBankAccountUpdateMutation = {
  __typename?: 'Mutation';
  CustomerBankAccountUpdate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type CountryDropdownQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CountryDropdownQuery = {
  __typename?: 'Query';
  CountryDropdown?: Array<{
    __typename?: 'Country';
    country_code?: string | null;
    country_currency_code?: string | null;
    country_id?: number | null;
    country_international_code?: string | null;
    country_name?: string | null;
    is_deleted?: number | null;
  } | null> | null;
};

export type StateDropdownQueryVariables = Types.Exact<{
  input: Types.Scalars['Int'];
}>;

export type StateDropdownQuery = {
  __typename?: 'Query';
  StateDropdown?: Array<{
    __typename?: 'State';
    is_deleted?: number | null;
    state_id?: number | null;
    state_name?: string | null;
  } | null> | null;
};

export type CityDropdownQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type CityDropdownQuery = {
  __typename?: 'Query';
  CityDropdown?: Array<{
    __typename?: 'City';
    city_id: number;
    city_name: string;
    is_deleted?: number | null;
  } | null> | null;
};

export type PaymentGroupListingStatusCountQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentListingInput>;
}>;

export type PaymentGroupListingStatusCountQuery = {
  __typename?: 'Query';
  PaymentGroupListingStatusCount?: Array<{
    __typename?: 'PaymentGroupStatusCount';
    payment_group_status?: string | null;
    count?: number | null;
  } | null> | null;
};

export type PaymentListingQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentListingInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type PaymentListingQuery = {
  __typename?: 'Query';
  PaymentListing?: {
    __typename?: 'PaymentPaginator';
    data: Array<{
      __typename?: 'Payment';
      is_refund_requested?: boolean | null;
      is_payment_repeat?: boolean | null;
      is_repeated?: boolean | null;
      payment_amount?: number | null;
      payment_amount_total?: number | null;
      payment_complete_date?: any | null;
      payment_created?: any | null;
      payment_end_date?: any | null;
      payment_extra_charges?: number | null;
      payment_extra_charges_rate?: number | null;
      payment_extra_charges_total?: number | null;
      payment_grandtotal?: number | null;
      payment_id?: number | null;
      payment_reference?: string | null;
      payment_referer_code?: string | null;
      payment_schedule_number_current?: number | null;
      payment_schedule_total_number?: number | null;
      payment_start_date?: any | null;
      payment_subtotal?: number | null;
      payment_updated?: any | null;
      payment_complete_media?: Array<{
        __typename?: 'Media';
        id?: number | null;
        collection_name?: string | null;
        name?: string | null;
        file_name?: string | null;
        mime_type?: string | null;
        url?: string | null;
        full_url?: string | null;
        path?: string | null;
        conversions?: any | null;
      } | null> | null;
      payment_status?: {
        __typename?: 'PaymentStatus';
        payment_status_id?: number | null;
        payment_status_name?: string | null;
      } | null;
      payment_type?: {
        __typename?: 'PaymentType';
        payment_type_name?: any | null;
      } | null;
      payment_schedule?: Array<{
        __typename?: 'PaymentSchedule';
        is_refund_requested?: boolean | null;
        payment_schedule_id?: number | null;
        payment_schedule_amount?: number | null;
        payment_schedule_number?: number | null;
        payment_schedule_complete_date?: any | null;
        payment_schedule_created?: any | null;
        payment_schedule_date?: any | null;
        payment_schedule_referer_code?: string | null;
        payment_status?: {
          __typename?: 'PaymentStatus';
          payment_status_id?: number | null;
          payment_status_name?: string | null;
        } | null;
        payment?: {
          __typename?: 'Payment';
          payment_amount?: number | null;
          payment_amount_total?: number | null;
          payment_complete_date?: any | null;
          payment_created?: any | null;
          payment_end_date?: any | null;
          payment_extra_charges?: number | null;
          payment_extra_charges_rate?: number | null;
          payment_extra_charges_total?: number | null;
          payment_grandtotal?: number | null;
          payment_id?: number | null;
          payment_reference?: string | null;
          payment_referer_code?: string | null;
          payment_schedule_number_current?: number | null;
          payment_schedule_total_number?: number | null;
          payment_start_date?: any | null;
          payment_subtotal?: number | null;
          payment_updated?: any | null;
          is_payment_repeat?: boolean | null;
          payment_recipient?: Array<{
            __typename?: 'PaymentRecipientDetails';
            payment_recipient_account_name?: string | null;
            payment_recipient_account_number?: string | null;
            payment_recipient_amount?: number | null;
          } | null> | null;
        } | null;
        payment_repeat_type?: {
          __typename?: 'PaymentRepeatType';
          payment_repeat_type_charges_rate?: number | null;
          payment_repeat_type_name?: any | null;
          is_extra_charges?: boolean | null;
        } | null;
        user_card?: {
          __typename?: 'UserCard';
          user_id?: number | null;
          user_card_id?: number | null;
          user_card_cardholder_name?: string | null;
          user_card_expiration_month?: number | null;
          user_card_expiration_year?: number | null;
          user_card_last_4_digit?: number | null;
        } | null;
        payment_schedule_complete_media?: Array<{
          __typename?: 'Media';
          file_name?: string | null;
          url?: string | null;
          full_url?: string | null;
          mime_type?: string | null;
        } | null> | null;
      } | null> | null;
      user_card?: {
        __typename?: 'UserCard';
        user_id?: number | null;
        user_card_id?: number | null;
        user_card_cardholder_name?: string | null;
        user_card_expiration_month?: number | null;
        user_card_expiration_year?: number | null;
        user_card_last_4_digit?: number | null;
      } | null;
      payment_recipient?: Array<{
        __typename?: 'PaymentRecipientDetails';
        payment_recipient_account_name?: string | null;
        payment_recipient_account_number?: string | null;
        payment_recipient_amount?: number | null;
        recipient?: {
          __typename?: 'Recipient';
          bank?: {
            __typename?: 'Bank';
            bank_name?: string | null;
            bank_logo?: { __typename?: 'Images'; thumb?: string | null } | null;
          } | null;
        } | null;
      } | null> | null;
      payment_repeat_type?: {
        __typename?: 'PaymentRepeatType';
        payment_repeat_type_charges_rate?: number | null;
        payment_repeat_type_name?: any | null;
        is_extra_charges?: boolean | null;
      } | null;
      payment_supporting_media?: Array<{
        __typename?: 'Media';
        file_name?: string | null;
        url?: string | null;
        mime_type?: string | null;
      } | null> | null;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
  } | null;
};

export type PaymentDetailQueryVariables = Types.Exact<{
  payment_id?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type PaymentDetailQuery = {
  __typename?: 'Query';
  PaymentDetail?: {
    __typename?: 'PaymentDetails';
    is_payment_repeat?: boolean | null;
    is_repeated?: boolean | null;
    payment_amount?: number | null;
    payment_amount_total?: number | null;
    payment_complete_date?: any | null;
    payment_created?: any | null;
    payment_end_date?: any | null;
    payment_extra_charges?: number | null;
    payment_extra_charges_rate?: number | null;
    payment_extra_charges_total?: number | null;
    payment_grandtotal?: number | null;
    payment_id?: number | null;
    payment_reference?: string | null;
    payment_referer_code?: string | null;
    payment_schedule_number_current?: number | null;
    payment_schedule_total_number?: number | null;
    payment_start_date?: any | null;
    payment_subtotal?: number | null;
    payment_updated?: any | null;
    payment_reject_details?: {
      __typename?: 'PaymentLog';
      payment_log_remark?: string | null;
      reject_reason?: {
        __typename?: 'RejectReason';
        reject_reason_name?: string | null;
        reject_reason_id?: number | null;
        reject_reason_description?: string | null;
        reject_reason_type?: string | null;
      } | null;
    } | null;
    payment_complete_media?: Array<{
      __typename?: 'Media';
      id?: number | null;
      collection_name?: string | null;
      name?: string | null;
      file_name?: string | null;
      mime_type?: string | null;
      url?: string | null;
      full_url?: string | null;
      path?: string | null;
      conversions?: any | null;
    } | null> | null;
    payment_status?: {
      __typename?: 'PaymentStatus';
      payment_status_id?: number | null;
      payment_status_name?: string | null;
    } | null;
    payment_type?: {
      __typename?: 'PaymentType';
      payment_type_name?: any | null;
    } | null;
    payment_schedule?: Array<{
      __typename?: 'PaymentSchedule';
      payment_schedule_id?: number | null;
      payment_schedule_amount?: number | null;
      payment_schedule_number?: number | null;
      payment_schedule_complete_date?: any | null;
      payment_schedule_created?: any | null;
      payment_schedule_date?: any | null;
      payment_schedule_referer_code?: string | null;
      payment_status?: {
        __typename?: 'PaymentStatus';
        payment_status_id?: number | null;
        payment_status_name?: string | null;
      } | null;
      payment?: {
        __typename?: 'Payment';
        payment_amount?: number | null;
        payment_amount_total?: number | null;
        payment_complete_date?: any | null;
        payment_created?: any | null;
        payment_end_date?: any | null;
        payment_extra_charges?: number | null;
        payment_extra_charges_rate?: number | null;
        payment_extra_charges_total?: number | null;
        payment_grandtotal?: number | null;
        payment_id?: number | null;
        payment_reference?: string | null;
        payment_referer_code?: string | null;
        payment_schedule_number_current?: number | null;
        payment_schedule_total_number?: number | null;
        payment_start_date?: any | null;
        payment_subtotal?: number | null;
        payment_updated?: any | null;
        is_payment_repeat?: boolean | null;
        payment_recipient?: Array<{
          __typename?: 'PaymentRecipientDetails';
          payment_recipient_account_name?: string | null;
          payment_recipient_account_number?: string | null;
          payment_recipient_amount?: number | null;
        } | null> | null;
      } | null;
      payment_repeat_type?: {
        __typename?: 'PaymentRepeatType';
        payment_repeat_type_charges_rate?: number | null;
        payment_repeat_type_name?: any | null;
        is_extra_charges?: boolean | null;
      } | null;
      user_card?: {
        __typename?: 'UserCard';
        user_id?: number | null;
        user_card_id?: number | null;
        user_card_cardholder_name?: string | null;
        user_card_expiration_month?: number | null;
        user_card_expiration_year?: number | null;
        user_card_last_4_digit?: number | null;
      } | null;
      payment_schedule_complete_media?: Array<{
        __typename?: 'Media';
        file_name?: string | null;
        url?: string | null;
        mime_type?: string | null;
      } | null> | null;
    } | null> | null;
    user_card?: {
      __typename?: 'UserCard';
      user_id?: number | null;
      user_card_id?: number | null;
      user_card_cardholder_name?: string | null;
      user_card_expiration_month?: number | null;
      user_card_expiration_year?: number | null;
      user_card_last_4_digit?: number | null;
    } | null;
    payment_recipient?: Array<{
      __typename?: 'PaymentRecipientDetails';
      payment_recipient_account_name?: string | null;
      payment_recipient_account_number?: string | null;
      payment_recipient_amount?: number | null;
      recipient?: {
        __typename?: 'Recipient';
        bank?: {
          __typename?: 'Bank';
          bank_name?: string | null;
          bank_logo?: { __typename?: 'Images'; thumb?: string | null } | null;
        } | null;
      } | null;
    } | null> | null;
    payment_repeat_type?: {
      __typename?: 'PaymentRepeatType';
      payment_repeat_type_charges_rate?: number | null;
      payment_repeat_type_name?: any | null;
      is_extra_charges?: boolean | null;
    } | null;
    payment_supporting_media?: Array<{
      __typename?: 'Media';
      file_name?: string | null;
      url?: string | null;
      mime_type?: string | null;
    } | null> | null;
  } | null;
};

export type PaymentCheckStatusQueryVariables = Types.Exact<{
  payment_id?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type PaymentCheckStatusQuery = {
  __typename?: 'Query';
  PaymentDetail?: {
    __typename?: 'PaymentDetails';
    payment_status?: {
      __typename?: 'PaymentStatus';
      payment_status_id?: number | null;
      payment_status_name?: string | null;
    } | null;
  } | null;
};

export type PaymentScheduleListingQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentScheduleListingInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type PaymentScheduleListingQuery = {
  __typename?: 'Query';
  PaymentScheduleListing?: {
    __typename?: 'PaymentSchedulePaginator';
    data: Array<{
      __typename?: 'PaymentSchedule';
      payment_schedule_id?: number | null;
      payment_schedule_referer_code?: string | null;
      payment_schedule_amount?: number | null;
      payment_schedule_number?: number | null;
      payment_schedule_complete_date?: any | null;
      payment_schedule_created?: any | null;
      payment_schedule_date?: any | null;
      payment_schedule_log?: Array<{
        __typename?: 'PaymentScheduleLog';
        payment_schedule_log_description?: string | null;
        payment_schedule_log_action?: string | null;
        payment_schedule_log_created?: any | null;
        payment_schedule_log_updated?: any | null;
        admin?: { __typename?: 'User'; user_fullname?: string | null } | null;
      } | null> | null;
      payment_status?: {
        __typename?: 'PaymentStatus';
        payment_status_id?: number | null;
        payment_status_name?: string | null;
      } | null;
      payment_schedule_complete_media?: Array<{
        __typename?: 'Media';
        id?: number | null;
        collection_name?: string | null;
        name?: string | null;
        file_name?: string | null;
        mime_type?: string | null;
        url?: string | null;
        full_url?: string | null;
        path?: string | null;
        conversions?: any | null;
      } | null> | null;
      customer?: {
        __typename?: 'Customer';
        customer_id?: number | null;
        customer_name?: string | null;
        customer_contact_person?: string | null;
      } | null;
      user_card?: {
        __typename?: 'UserCard';
        user_id?: number | null;
        user_card_id?: number | null;
        user_card_cardholder_name?: string | null;
        user_card_expiration_month?: number | null;
        user_card_expiration_year?: number | null;
        user_card_last_4_digit?: number | null;
      } | null;
      payment?: {
        __typename?: 'Payment';
        payment_schedule_total_number?: number | null;
        payment_amount_total?: number | null;
        payment_amount?: number | null;
        payment_id?: number | null;
        payment_reference?: string | null;
        is_payment_repeat?: boolean | null;
        payment_schedule?: Array<{
          __typename?: 'PaymentSchedule';
          payment_schedule_referer_code?: string | null;
          payment_schedule_date?: any | null;
          payment_schedule_amount?: number | null;
          payment_schedule_number?: number | null;
          payment_status?: {
            __typename?: 'PaymentStatus';
            payment_status_id?: number | null;
            payment_status_name?: string | null;
          } | null;
        } | null> | null;
        payment_type?: {
          __typename?: 'PaymentType';
          payment_type_name?: any | null;
        } | null;
        payment_recipient?: Array<{
          __typename?: 'PaymentRecipientDetails';
          payment_recipient_account_name?: string | null;
          payment_recipient_account_number?: string | null;
          payment_recipient_amount?: number | null;
        } | null> | null;
      } | null;
      payment_recipient?: Array<{
        __typename?: 'PaymentRecipientDetails';
        payment_recipient_account_name?: string | null;
        payment_recipient_account_number?: string | null;
        payment_recipient_amount?: number | null;
        payment?: {
          __typename?: 'Payment';
          payment_reference?: string | null;
        } | null;
        recipient?: {
          __typename?: 'Recipient';
          recipient_id?: number | null;
          recipient_bank_holder_name?: string | null;
          recipient_bank_account_number?: string | null;
          recipient_type?: Types.RecipientType | null;
          recipient_category?: {
            __typename?: 'RecipientCategory';
            recipient_category_name?: string | null;
          } | null;
          bank?: {
            __typename?: 'Bank';
            bank_name?: string | null;
            bank_logo?: { __typename?: 'Images'; thumb?: string | null } | null;
          } | null;
        } | null;
      } | null> | null;
      payment_repeat_type?: {
        __typename?: 'PaymentRepeatType';
        payment_repeat_type_charges_rate?: number | null;
        payment_repeat_type_name?: any | null;
        is_extra_charges?: boolean | null;
      } | null;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
  } | null;
};

export type PaymentTypeDropdownQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type PaymentTypeDropdownQuery = {
  __typename?: 'Query';
  PaymentTypeDropdown?: Array<{
    __typename?: 'PaymentTypeDropdown';
    payment_type_id?: number | null;
    payment_type_name?: any | null;
    payment_type_document?: string | null;
    is_allowed_payment_repeat?: boolean | null;
  } | null> | null;
};

export type PaymentStatusDropdownQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type PaymentStatusDropdownQuery = {
  __typename?: 'Query';
  PaymentStatusDropdown?: Array<{
    __typename?: 'PaymentStatus';
    payment_status_id?: number | null;
    payment_status_name?: string | null;
    payment_status_desc?: string | null;
  } | null> | null;
};

export type PaymentRepeatTypeDropdownQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentRepeatTypeCategory>;
}>;

export type PaymentRepeatTypeDropdownQuery = {
  __typename?: 'Query';
  PaymentRepeatTypeDropdown?: Array<{
    __typename?: 'PaymentRepeatTypeDropdown';
    payment_repeat_type_id?: number | null;
    payment_repeat_type_name?: any | null;
    payment_repeat_type_charges_type?: string | null;
    payment_repeat_type_charges_rate?: number | null;
    payment_repeat_type_category?: string | null;
    payment_repeat_type_additional_days?: number | null;
    standard_fee?: number | null;
    is_extra_charges?: boolean | null;
  } | null> | null;
};

export type PaymentListingExportQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentListingInput>;
}>;

export type PaymentListingExportQuery = {
  __typename?: 'Query';
  PaymentListingExport?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type PaymentScheduleListingExportQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentScheduleListingInput>;
}>;

export type PaymentScheduleListingExportQuery = {
  __typename?: 'Query';
  PaymentScheduleListingExport?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type PaymentCreateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentCreateInput>;
}>;

export type PaymentCreateMutation = {
  __typename?: 'Mutation';
  PaymentCreate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type PaymentCancelMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type PaymentCancelMutation = {
  __typename?: 'Mutation';
  PaymentCancel?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type PaymentScheduleCancelMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type PaymentScheduleCancelMutation = {
  __typename?: 'Mutation';
  PaymentScheduleCancel?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type PaymentListingStatusCountQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentListingInput>;
}>;

export type PaymentListingStatusCountQuery = {
  __typename?: 'Query';
  PaymentListingStatusCount?: Array<{
    __typename?: 'PaymentStatusCount';
    payment_status_id?: number | null;
    payment_status_name?: string | null;
    count?: number | null;
  } | null> | null;
};

export type PaymentMakeQueryVariables = Types.Exact<{
  payment_id?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type PaymentMakeQuery = {
  __typename?: 'Query';
  PaymentMake?: {
    __typename?: 'PaymentMake';
    payment_url?: string | null;
    payment_number?: string | null;
    payment?: {
      __typename?: 'Payment';
      payment_subtotal?: number | null;
      payment_extra_charges_rate?: number | null;
      payment_extra_charges?: number | null;
      payment_amount?: number | null;
      payment_referer_code?: string | null;
      payment_reference?: string | null;
      payment_type?: {
        __typename?: 'PaymentType';
        payment_type_name?: any | null;
      } | null;
      payment_repeat_type?: {
        __typename?: 'PaymentRepeatType';
        payment_repeat_type_name?: any | null;
      } | null;
      payment_schedule?: Array<{
        __typename?: 'PaymentSchedule';
        payment_schedule_date?: any | null;
      } | null> | null;
      payment_recipient?: Array<{
        __typename?: 'PaymentRecipientDetails';
        payment_recipient_account_name?: string | null;
        payment_recipient_account_number?: string | null;
        recipient?: {
          __typename?: 'Recipient';
          bank?: { __typename?: 'Bank'; bank_name?: string | null } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type PaymentRefundMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentRefundInput>;
}>;

export type PaymentRefundMutation = {
  __typename?: 'Mutation';
  PaymentRefund?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type PaymentScheduleRefundMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentScheduleRefundInput>;
}>;

export type PaymentScheduleRefundMutation = {
  __typename?: 'Mutation';
  PaymentScheduleRefund?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type PaymentScheduleMakeMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type PaymentScheduleMakeMutation = {
  __typename?: 'Mutation';
  PaymentScheduleMake?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type UserCardListingQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.UserCardListingInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type UserCardListingQuery = {
  __typename?: 'Query';
  UserCardListing?: {
    __typename?: 'UserCardListingPaginator';
    data: Array<{
      __typename?: 'UserCardListing';
      is_default_card?: boolean | null;
      is_deleted?: boolean | null;
      user_card_created?: any | null;
      user_card_expiration_month?: number | null;
      user_card_expiration_year?: number | null;
      user_card_id?: number | null;
      user_card_last_4_digit?: number | null;
      user_card_status?: string | null;
      user_card_updated?: any | null;
      user?: {
        __typename?: 'User';
        user_id?: number | null;
        user_fullname?: string | null;
      } | null;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
  } | null;
};

export type UserCardDropdownQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type UserCardDropdownQuery = {
  __typename?: 'Query';
  UserCardDropdown?: Array<{
    __typename?: 'UserCardDropdown';
    user_card_id?: number | null;
    user_card_cardholder_name?: string | null;
    user_card_network_type?: string | null;
    user_card_expiration_month?: number | null;
    user_card_expiration_year?: number | null;
    user_card_last_4_digit?: number | null;
    is_default_card?: boolean | null;
    user?: { __typename?: 'User'; user_fullname?: string | null } | null;
  } | null> | null;
};

export type UserCardCreateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.UserCardCreateInput>;
}>;

export type UserCardCreateMutation = {
  __typename?: 'Mutation';
  UserCardCreate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type UserCardUpdateDefaultMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.UserCardUpdateDefaultInput>;
}>;

export type UserCardUpdateDefaultMutation = {
  __typename?: 'Mutation';
  UserCardUpdateDefault?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type UserCardDeleteMutationVariables = Types.Exact<{
  user_card_id: Types.Scalars['Int'];
}>;

export type UserCardDeleteMutation = {
  __typename?: 'Mutation';
  UserCardDelete?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type UserProfileImageUploadMutationVariables = Types.Exact<{
  file?: Types.InputMaybe<Types.Scalars['Upload']>;
}>;

export type UserProfileImageUploadMutation = {
  __typename?: 'Mutation';
  UserProfileImageUpload: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  };
};

export type RecipientListingQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.RecipientListingInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type RecipientListingQuery = {
  __typename?: 'Query';
  RecipientListing?: {
    __typename?: 'RecipientListingPaginator';
    data: Array<{
      __typename?: 'RecipientListing';
      recipient_id?: number | null;
      recipient_email?: string | null;
      recipient_mobile_number?: string | null;
      recipient_bank_holder_name?: string | null;
      recipient_bank_account_number?: string | null;
      total_amount?: number | null;
      bank?: {
        __typename?: 'Bank';
        bank_id?: number | null;
        bank_name?: string | null;
      } | null;
      recipient_category?: {
        __typename?: 'RecipientCategory';
        recipient_category_id?: number | null;
        recipient_category_name?: string | null;
      } | null;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
  } | null;
};

export type RecipientCategoryDropdownQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type RecipientCategoryDropdownQuery = {
  __typename?: 'Query';
  RecipientCategoryDropdown?: Array<{
    __typename?: 'RecipientCategory';
    recipient_category_id?: number | null;
    recipient_category_name?: string | null;
    is_deleted?: boolean | null;
  } | null> | null;
};

export type RecipientListingExportQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.RecipientListingInput>;
}>;

export type RecipientListingExportQuery = {
  __typename?: 'Query';
  RecipientListingExport?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type RecipientCreateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.RecipientCreateInput>;
}>;

export type RecipientCreateMutation = {
  __typename?: 'Mutation';
  RecipientCreate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type RecipientDeleteMutationVariables = Types.Exact<{
  recipient_id: Types.Scalars['Int'];
}>;

export type RecipientDeleteMutation = {
  __typename?: 'Mutation';
  RecipientDelete?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type BankDropdownQueryVariables = Types.Exact<{ [key: string]: never }>;

export type BankDropdownQuery = {
  __typename?: 'Query';
  BankDropdown?: Array<{
    __typename?: 'Bank';
    bank_id?: number | null;
    bank_name?: string | null;
    is_deleted?: number | null;
    bank_logo?: { __typename?: 'Images'; thumb?: string | null } | null;
  } | null> | null;
};

export type BankNameSearchQueryVariables = Types.Exact<{
  input: Types.Scalars['String'];
}>;

export type BankNameSearchQuery = {
  __typename?: 'Query';
  BankNameSearch?: {
    __typename?: 'Bank';
    bank_id?: number | null;
    bank_name?: string | null;
  } | null;
};

export type BusinessTypeDropdownQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type BusinessTypeDropdownQuery = {
  __typename?: 'Query';
  BusinessTypeDropdown?: Array<{
    __typename?: 'BusinessType';
    business_type_id?: number | null;
    business_type_name?: any | null;
    business_type_status?: string | null;
    is_deleted?: boolean | null;
  } | null> | null;
};

export type BusinessYearDropdownQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type BusinessYearDropdownQuery = {
  __typename?: 'Query';
  BusinessYearDropdown?: Array<{
    __typename?: 'BusinessYear';
    year_of_business_id?: number | null;
    year_of_business_name?: any | null;
    year_of_business_status?: string | null;
    is_deleted?: boolean | null;
  } | null> | null;
};

export type RejectReasonDropdownQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.RejectReasonType>;
}>;

export type RejectReasonDropdownQuery = {
  __typename?: 'Query';
  RejectReasonDropdown?: Array<{
    __typename?: 'RejectReason';
    reject_reason_id?: number | null;
    reject_reason_name?: string | null;
    reject_reason_description?: string | null;
    reject_reason_type?: string | null;
    is_deleted?: boolean | null;
  } | null> | null;
};

export type AnnualRevenueDropdownQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type AnnualRevenueDropdownQuery = {
  __typename?: 'Query';
  AnnualRevenueDropdown?: Array<{
    __typename?: 'AnnualRevenue';
    setting_annual_revenue_id?: number | null;
    setting_annual_revenue_name?: string | null;
  } | null> | null;
};

export type CompanySizeDropdownQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type CompanySizeDropdownQuery = {
  __typename?: 'Query';
  CompanySizeDropdown?: Array<{
    __typename?: 'CompanySize';
    setting_company_size_id?: number | null;
    setting_company_size_name?: string | null;
  } | null> | null;
};

export type MerchantCustomerListingQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.MerchantCustomerListingInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type MerchantCustomerListingQuery = {
  __typename?: 'Query';
  MerchantCustomerListing?: {
    __typename?: 'MerchantCustomerPaginator';
    data: Array<{
      __typename?: 'MerchantCustomer';
      merchant_customer_id?: number | null;
      merchant_customer_company_name?: string | null;
      merchant_customer_registration_number?: string | null;
      merchant_customer_email?: string | null;
      full_address?: string | null;
      merchant_customer_phone_number?: string | null;
      merchant_customer_name?: string | null;
      merchant_customer_status?: Types.CustomerMerchantStatus | null;
      merchant_customer_created?: any | null;
      merchant_customer_address_1?: string | null;
      merchant_customer_address_2?: string | null;
      merchant_customer_postcode?: string | null;
      payment_link_transaction_total?: number | null;
      payment_link_transaction_count?: number | null;
      state?: {
        __typename?: 'State';
        state_id?: number | null;
        state_name?: string | null;
      } | null;
      country?: {
        __typename?: 'Country';
        country_id?: number | null;
        country_name?: string | null;
      } | null;
      city?: { __typename?: 'City'; city_id: number; city_name: string } | null;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
  } | null;
};

export type MerchantCustomerDropdownQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type MerchantCustomerDropdownQuery = {
  __typename?: 'Query';
  MerchantCustomerDropdown?: Array<{
    __typename?: 'MerchantCustomerDropdown';
    merchant_customer_id?: number | null;
    merchant_customer_name?: string | null;
    merchant_customer_company_name?: string | null;
    merchant_customer_registration_number?: string | null;
  } | null> | null;
};

export type MerchantCustomerDetailQueryVariables = Types.Exact<{
  merchant_customer_id?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type MerchantCustomerDetailQuery = {
  __typename?: 'Query';
  MerchantCustomerDetail?: {
    __typename?: 'MerchantCustomer';
    merchant_customer_id?: number | null;
    merchant_customer_company_name?: string | null;
    merchant_customer_registration_number?: string | null;
    merchant_customer_email?: string | null;
    full_address?: string | null;
    merchant_customer_phone_number?: string | null;
    merchant_customer_name?: string | null;
    merchant_customer_status?: Types.CustomerMerchantStatus | null;
    merchant_customer_created?: any | null;
    merchant_customer_address_1?: string | null;
    merchant_customer_address_2?: string | null;
    merchant_customer_postcode?: string | null;
    payment_link_transaction_total?: number | null;
    payment_link_transaction_count?: number | null;
    state?: {
      __typename?: 'State';
      state_id?: number | null;
      state_name?: string | null;
    } | null;
    country?: {
      __typename?: 'Country';
      country_id?: number | null;
      country_name?: string | null;
    } | null;
    city?: { __typename?: 'City'; city_id: number; city_name: string } | null;
  } | null;
};

export type MerchantCustomerStatusCountQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.MerchantCustomerListingInput>;
}>;

export type MerchantCustomerStatusCountQuery = {
  __typename?: 'Query';
  MerchantCustomerStatusCount?: Array<{
    __typename?: 'MerchantCustomerStatusCount';
    merchant_customer_status?: string | null;
    status_count?: number | null;
  } | null> | null;
};

export type MerchantCustomerCreateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.MerchantCustomerCreateInput>;
}>;

export type MerchantCustomerCreateMutation = {
  __typename?: 'Mutation';
  MerchantCustomerCreate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type MerchantCustomerUpdateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.MerchantCustomerUpdateInput>;
}>;

export type MerchantCustomerUpdateMutation = {
  __typename?: 'Mutation';
  MerchantCustomerUpdate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type MerchantCustomerStatusUpdateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.MerchantCustomerStatusUpdateInput>;
}>;

export type MerchantCustomerStatusUpdateMutation = {
  __typename?: 'Mutation';
  MerchantCustomerStatusUpdate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type PaymentLinkListingQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentLinkListingInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  page?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type PaymentLinkListingQuery = {
  __typename?: 'Query';
  PaymentLinkListing?: {
    __typename?: 'PaymentLinkPaginator';
    data: Array<{
      __typename?: 'PaymentLink';
      payment_id?: number | null;
      payment_amount?: number | null;
      payment_amount_total?: number | null;
      payment_referer_code?: string | null;
      payment_extra_charges_rate?: number | null;
      payment_extra_charges_type?: string | null;
      payment_link?: string | null;
      payment_expired_date?: any | null;
      payment_created?: any | null;
      payment_reference?: string | null;
      payment_grandtotal?: number | null;
      payment_extra_charges_total?: number | null;
      payment_extra_charges?: number | null;
      paid_by?: Types.PaymentLinkPaidBy | null;
      payment_status?: {
        __typename?: 'PaymentStatus';
        payment_status_name?: string | null;
      } | null;
      merchant_customer?: {
        __typename?: 'MerchantCustomer';
        merchant_customer_name?: string | null;
        merchant_customer_company_name?: string | null;
        merchant_customer_registration_number?: string | null;
      } | null;
      customer?: {
        __typename?: 'Customer';
        customer_name?: string | null;
        customer_registration_number?: string | null;
        customer_bank_account_name?: string | null;
        customer_bank_account_number?: string | null;
        bank?: { __typename?: 'Bank'; bank_name?: string | null } | null;
      } | null;
      payment_log?: Array<{
        __typename?: 'PaymentLog';
        payment_log_action?: string | null;
        payment_log_description?: string | null;
        payment_log_remark?: string | null;
        payment_log_created?: any | null;
        user?: { __typename?: 'User'; user_fullname?: string | null } | null;
      } | null> | null;
    }>;
    paginatorInfo: {
      __typename?: 'PaginatorInfo';
      count: number;
      currentPage: number;
      firstItem?: number | null;
      hasMorePages: boolean;
      lastItem?: number | null;
      lastPage: number;
      perPage: number;
      total: number;
    };
  } | null;
};

export type PaymentLinkMakeQueryVariables = Types.Exact<{
  payment_id?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type PaymentLinkMakeQuery = {
  __typename?: 'Query';
  PaymentLinkMake?: {
    __typename?: 'PaymentMake';
    payment_url?: string | null;
    payment_number?: string | null;
  } | null;
};

export type PaymentLinkDetailQueryVariables = Types.Exact<{
  payment_id?: Types.InputMaybe<Types.Scalars['Int']>;
}>;

export type PaymentLinkDetailQuery = {
  __typename?: 'Query';
  PaymentLinkDetail?: {
    __typename?: 'PaymentLink';
    payment_id?: number | null;
    payment_amount?: number | null;
    payment_amount_total?: number | null;
    payment_referer_code?: string | null;
    payment_extra_charges_rate?: number | null;
    payment_extra_charges_type?: string | null;
    payment_link?: string | null;
    payment_expired_date?: any | null;
    payment_created?: any | null;
    payment_reference?: string | null;
    payment_grandtotal?: number | null;
    payment_extra_charges_total?: number | null;
    payment_extra_charges?: number | null;
    paid_by?: Types.PaymentLinkPaidBy | null;
    payment_status?: {
      __typename?: 'PaymentStatus';
      payment_status_name?: string | null;
    } | null;
    merchant_customer?: {
      __typename?: 'MerchantCustomer';
      merchant_customer_name?: string | null;
      merchant_customer_company_name?: string | null;
      merchant_customer_registration_number?: string | null;
    } | null;
    customer?: {
      __typename?: 'Customer';
      customer_name?: string | null;
      customer_registration_number?: string | null;
      customer_bank_account_name?: string | null;
      customer_bank_account_number?: string | null;
      bank?: { __typename?: 'Bank'; bank_name?: string | null } | null;
    } | null;
    payment_log?: Array<{
      __typename?: 'PaymentLog';
      payment_log_action?: string | null;
      payment_log_description?: string | null;
      payment_log_remark?: string | null;
      payment_log_created?: any | null;
      user?: { __typename?: 'User'; user_fullname?: string | null } | null;
    } | null> | null;
  } | null;
};

export type PaymentLinkStatusCountQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentLinkListingInput>;
}>;

export type PaymentLinkStatusCountQuery = {
  __typename?: 'Query';
  PaymentLinkStatusCount?: Array<{
    __typename?: 'PaymentLinkStatusCount';
    payment_status?: string | null;
    count?: number | null;
  } | null> | null;
};

export type PaymentLinkReferenceQueryVariables = Types.Exact<{
  payment_referer_code?: Types.InputMaybe<Types.Scalars['String']>;
}>;

export type PaymentLinkReferenceQuery = {
  __typename?: 'Query';
  PaymentLinkReference?: {
    __typename?: 'PaymentLink';
    payment_id?: number | null;
    payment_amount?: number | null;
    payment_amount_total?: number | null;
    payment_referer_code?: string | null;
    payment_extra_charges_rate?: number | null;
    payment_extra_charges_type?: string | null;
    payment_link?: string | null;
    payment_expired_date?: any | null;
    payment_created?: any | null;
    payment_reference?: string | null;
    payment_grandtotal?: number | null;
    payment_extra_charges_total?: number | null;
    payment_extra_charges?: number | null;
    paid_by?: Types.PaymentLinkPaidBy | null;
    payment_status?: {
      __typename?: 'PaymentStatus';
      payment_status_name?: string | null;
    } | null;
    merchant_customer?: {
      __typename?: 'MerchantCustomer';
      merchant_customer_name?: string | null;
      merchant_customer_company_name?: string | null;
      merchant_customer_registration_number?: string | null;
    } | null;
    customer?: {
      __typename?: 'Customer';
      customer_name?: string | null;
      customer_registration_number?: string | null;
      customer_bank_account_name?: string | null;
      customer_bank_account_number?: string | null;
      bank?: { __typename?: 'Bank'; bank_name?: string | null } | null;
    } | null;
    payment_log?: Array<{
      __typename?: 'PaymentLog';
      payment_log_action?: string | null;
      payment_log_description?: string | null;
      payment_log_remark?: string | null;
      payment_log_created?: any | null;
      user?: { __typename?: 'User'; user_fullname?: string | null } | null;
    } | null> | null;
  } | null;
};

export type PaymentLinkCreateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentLinkCreateInput>;
}>;

export type PaymentLinkCreateMutation = {
  __typename?: 'Mutation';
  PaymentLinkCreate?: {
    __typename?: 'SuccessResponse';
    status: boolean;
    message?: string | null;
    data?: any | null;
  } | null;
};

export type PaymentLinkCalculateMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.PaymentLinkCalculateInput>;
}>;

export type PaymentLinkCalculateMutation = {
  __typename?: 'Mutation';
  PaymentLinkCalculate?: {
    __typename?: 'PaymentCalculation';
    payment_subtotal?: number | null;
    payment_amount?: number | null;
    payment_standard_fee_rate?: number | null;
    payment_extra_charges_rate?: number | null;
    payment_extra_charges?: number | null;
    payment_grandtotal?: number | null;
  } | null;
};

export type SuccessResponseFragment = {
  __typename?: 'SuccessResponse';
  status: boolean;
  message?: string | null;
  data?: any | null;
};

export type TokenResponseFragment = {
  __typename?: 'TokenResponse';
  token?: string | null;
  token_type?: string | null;
};

export type UserTypeInfoFragment = {
  __typename?: 'UserType';
  user_type_id: number;
  user_type_name: string;
  user_type_slug: string;
  user_type_group?: string | null;
};

export type UserRoleInfoFragment = {
  __typename?: 'Role';
  id?: number | null;
  name?: string | null;
};

export type UserPermissionInfoFragment = {
  __typename?: 'Permission';
  id?: number | null;
  name?: string | null;
  group_name?: string | null;
  display_name?: string | null;
};

export type ImageInfoFragment = {
  __typename?: 'Images';
  media_id?: number | null;
  full?: string | null;
  thumb?: string | null;
};

export type UserBasicInfoFragment = {
  __typename?: 'User';
  user_id?: number | null;
  username?: string | null;
  user_email?: string | null;
  user_alternative_email?: string | null;
  user_fullname?: string | null;
  user_nric?: string | null;
  user_gender?: Types.UserGender | null;
  user_address?: string | null;
  user_address2?: string | null;
  user_postcode?: string | null;
  user_dob?: any | null;
  user_status?: Types.UserStatus | null;
  user_logindate?: any | null;
  user_ip?: string | null;
  is_deleted?: boolean | null;
  user_mobile?: string | null;
  user_alternative_mobile?: string | null;
  user_mobile_verified?: boolean | null;
  user_join_date?: any | null;
  email_verified_at?: any | null;
  user_code?: string | null;
  user_created?: any | null;
  user_updated?: any | null;
  user_language?: string | null;
};

export type UserInfoFragment = {
  __typename?: 'User';
  user_id?: number | null;
  username?: string | null;
  user_email?: string | null;
  user_alternative_email?: string | null;
  user_fullname?: string | null;
  user_nric?: string | null;
  user_gender?: Types.UserGender | null;
  user_address?: string | null;
  user_address2?: string | null;
  user_postcode?: string | null;
  user_dob?: any | null;
  user_status?: Types.UserStatus | null;
  user_logindate?: any | null;
  user_ip?: string | null;
  is_deleted?: boolean | null;
  user_mobile?: string | null;
  user_alternative_mobile?: string | null;
  user_mobile_verified?: boolean | null;
  user_join_date?: any | null;
  email_verified_at?: any | null;
  user_code?: string | null;
  user_created?: any | null;
  user_updated?: any | null;
  user_language?: string | null;
  user_nationality?: {
    __typename?: 'Country';
    country_code?: string | null;
    country_currency_code?: string | null;
    country_id?: number | null;
    country_international_code?: string | null;
    country_name?: string | null;
    is_deleted?: number | null;
  } | null;
  user_city?: {
    __typename?: 'City';
    city_id: number;
    city_name: string;
    is_deleted?: number | null;
  } | null;
  user_state?: {
    __typename?: 'State';
    is_deleted?: number | null;
    state_id?: number | null;
    state_name?: string | null;
  } | null;
  user_type?: {
    __typename?: 'UserType';
    user_type_id: number;
    user_type_name: string;
    user_type_slug: string;
    user_type_group?: string | null;
  } | null;
  user_role?: {
    __typename?: 'Role';
    id?: number | null;
    name?: string | null;
  } | null;
  user_permissions?: Array<{
    __typename?: 'Permission';
    id?: number | null;
    name?: string | null;
    group_name?: string | null;
    display_name?: string | null;
  } | null> | null;
  user_profile_image?: {
    __typename?: 'Images';
    media_id?: number | null;
    full?: string | null;
    thumb?: string | null;
  } | null;
  customer?: {
    __typename?: 'Customer';
    customer_id?: number | null;
    customer_registration_number?: string | null;
    customer_type?: Types.CustomerType | null;
    customer_name?: string | null;
    customer_website?: string | null;
    customer_address?: string | null;
    customer_postcode?: string | null;
    customer_address2?: string | null;
    customer_mobile?: string | null;
    customer_fax?: string | null;
    customer_email?: string | null;
    reject_reason_remark?: string | null;
    customer_contact_person?: string | null;
    customer_contact_person_mobile?: string | null;
    customer_status?: Types.CustomerStatus | null;
    customer_remark?: string | null;
    customer_created?: any | null;
    customer_updated?: any | null;
    is_deleted?: boolean | null;
    customer_bank_account_name?: string | null;
    customer_bank_account_number?: string | null;
    city?: { __typename?: 'City'; city_id: number; city_name: string } | null;
    state?: {
      __typename?: 'State';
      state_id?: number | null;
      state_name?: string | null;
    } | null;
    country?: {
      __typename?: 'Country';
      country_id?: number | null;
      country_name?: string | null;
    } | null;
    setting_annual_revenue?: {
      __typename?: 'AnnualRevenue';
      setting_annual_revenue_id?: number | null;
      setting_annual_revenue_name?: string | null;
    } | null;
    setting_company_size?: {
      __typename?: 'CompanySize';
      setting_company_size_id?: number | null;
      setting_company_size_name?: string | null;
    } | null;
    customer_question?: Array<{
      __typename?: 'CustomerQuestion';
      customer_question_id?: number | null;
      customer_question_title?: string | null;
      customer_question_value?: any | null;
      customer_question_created?: any | null;
      question?: {
        __typename?: 'Question';
        question_title?: string | null;
        question_value?: any | null;
        question_id: number;
      } | null;
    } | null> | null;
    ssm_business_certificate?: Array<{
      __typename?: 'Media';
      id?: number | null;
      url?: string | null;
      full_url?: string | null;
      file_name?: string | null;
      mime_type?: string | null;
    } | null> | null;
    reject_reason?: {
      __typename?: 'RejectReason';
      reject_reason_name?: string | null;
      reject_reason_id?: number | null;
    } | null;
    business_year?: {
      __typename?: 'BusinessYear';
      year_of_business_id?: number | null;
      year_of_business_name?: any | null;
    } | null;
    business_type?: {
      __typename?: 'BusinessType';
      business_type_id?: number | null;
      business_type_name?: any | null;
    } | null;
    bank?: {
      __typename?: 'Bank';
      bank_id?: number | null;
      bank_name?: string | null;
    } | null;
  } | null;
};

export type QuestionTypeInfoFragment = {
  __typename?: 'Question';
  question_id: number;
  question_title?: string | null;
  question_value?: any | null;
  question_priority?: number | null;
  question_section?: number | null;
  question_status?: Types.QuestionStatus | null;
  question_type?: string | null;
  question_value_column?: number | null;
};

export type CustomerQuestionTypeInfoFragment = {
  __typename?: 'CustomerQuestion';
  customer_question_id?: number | null;
  customer_question_title?: string | null;
  customer_question_value?: any | null;
  customer_question_created?: any | null;
  question?: {
    __typename?: 'Question';
    question_id: number;
    question_title?: string | null;
    question_value?: any | null;
    question_priority?: number | null;
    question_section?: number | null;
    question_status?: Types.QuestionStatus | null;
    question_type?: string | null;
    question_value_column?: number | null;
  } | null;
};

export type CustomerBasicInfoFragment = {
  __typename?: 'Customer';
  customer_id?: number | null;
  customer_registration_number?: string | null;
  customer_type?: Types.CustomerType | null;
  customer_name?: string | null;
  customer_website?: string | null;
  customer_address?: string | null;
  customer_postcode?: string | null;
  customer_address2?: string | null;
  customer_mobile?: string | null;
  customer_fax?: string | null;
  customer_email?: string | null;
  reject_reason_remark?: string | null;
  customer_contact_person?: string | null;
  customer_contact_person_mobile?: string | null;
  customer_status?: Types.CustomerStatus | null;
  customer_remark?: string | null;
  customer_created?: any | null;
  customer_updated?: any | null;
  is_deleted?: boolean | null;
  customer_bank_account_name?: string | null;
  customer_bank_account_number?: string | null;
  city?: { __typename?: 'City'; city_id: number; city_name: string } | null;
  state?: {
    __typename?: 'State';
    state_id?: number | null;
    state_name?: string | null;
  } | null;
  country?: {
    __typename?: 'Country';
    country_id?: number | null;
    country_name?: string | null;
  } | null;
  setting_annual_revenue?: {
    __typename?: 'AnnualRevenue';
    setting_annual_revenue_id?: number | null;
    setting_annual_revenue_name?: string | null;
  } | null;
  setting_company_size?: {
    __typename?: 'CompanySize';
    setting_company_size_id?: number | null;
    setting_company_size_name?: string | null;
  } | null;
  customer_question?: Array<{
    __typename?: 'CustomerQuestion';
    customer_question_id?: number | null;
    customer_question_title?: string | null;
    customer_question_value?: any | null;
    customer_question_created?: any | null;
    question?: {
      __typename?: 'Question';
      question_title?: string | null;
      question_value?: any | null;
      question_id: number;
    } | null;
  } | null> | null;
  ssm_business_certificate?: Array<{
    __typename?: 'Media';
    id?: number | null;
    url?: string | null;
    full_url?: string | null;
    file_name?: string | null;
    mime_type?: string | null;
  } | null> | null;
  reject_reason?: {
    __typename?: 'RejectReason';
    reject_reason_name?: string | null;
    reject_reason_id?: number | null;
  } | null;
  business_year?: {
    __typename?: 'BusinessYear';
    year_of_business_id?: number | null;
    year_of_business_name?: any | null;
  } | null;
  business_type?: {
    __typename?: 'BusinessType';
    business_type_id?: number | null;
    business_type_name?: any | null;
  } | null;
  bank?: {
    __typename?: 'Bank';
    bank_id?: number | null;
    bank_name?: string | null;
  } | null;
};

export type CustomerTypeInfoFragment = {
  __typename?: 'Customer';
  customer_id?: number | null;
  customer_registration_number?: string | null;
  customer_type?: Types.CustomerType | null;
  customer_name?: string | null;
  customer_website?: string | null;
  customer_address?: string | null;
  customer_postcode?: string | null;
  customer_address2?: string | null;
  customer_mobile?: string | null;
  customer_fax?: string | null;
  customer_email?: string | null;
  reject_reason_remark?: string | null;
  customer_contact_person?: string | null;
  customer_contact_person_mobile?: string | null;
  customer_status?: Types.CustomerStatus | null;
  customer_remark?: string | null;
  customer_created?: any | null;
  customer_updated?: any | null;
  is_deleted?: boolean | null;
  customer_bank_account_name?: string | null;
  customer_bank_account_number?: string | null;
  city?: {
    __typename?: 'City';
    city_id: number;
    city_name: string;
    is_deleted?: number | null;
  } | null;
  state?: {
    __typename?: 'State';
    state_id?: number | null;
    state_name?: string | null;
    is_deleted?: number | null;
  } | null;
  country?: {
    __typename?: 'Country';
    country_id?: number | null;
    country_name?: string | null;
    country_code?: string | null;
    country_currency_code?: string | null;
    country_international_code?: string | null;
    is_deleted?: number | null;
  } | null;
  customer_question?: Array<{
    __typename?: 'CustomerQuestion';
    customer_question_id?: number | null;
    customer_question_title?: string | null;
    customer_question_value?: any | null;
    customer_question_created?: any | null;
    question?: {
      __typename?: 'Question';
      question_title?: string | null;
      question_value?: any | null;
      question_id: number;
      question_priority?: number | null;
      question_section?: number | null;
      question_status?: Types.QuestionStatus | null;
      question_type?: string | null;
      question_value_column?: number | null;
    } | null;
  } | null> | null;
  setting_annual_revenue?: {
    __typename?: 'AnnualRevenue';
    setting_annual_revenue_id?: number | null;
    setting_annual_revenue_name?: string | null;
  } | null;
  setting_company_size?: {
    __typename?: 'CompanySize';
    setting_company_size_id?: number | null;
    setting_company_size_name?: string | null;
  } | null;
  ssm_business_certificate?: Array<{
    __typename?: 'Media';
    id?: number | null;
    url?: string | null;
    full_url?: string | null;
    file_name?: string | null;
    mime_type?: string | null;
  } | null> | null;
  reject_reason?: {
    __typename?: 'RejectReason';
    reject_reason_name?: string | null;
    reject_reason_id?: number | null;
  } | null;
  business_year?: {
    __typename?: 'BusinessYear';
    year_of_business_id?: number | null;
    year_of_business_name?: any | null;
  } | null;
  business_type?: {
    __typename?: 'BusinessType';
    business_type_id?: number | null;
    business_type_name?: any | null;
  } | null;
  bank?: {
    __typename?: 'Bank';
    bank_id?: number | null;
    bank_name?: string | null;
  } | null;
};

export type PaginatorInfoFragment = {
  __typename?: 'PaginatorInfo';
  count: number;
  currentPage: number;
  firstItem?: number | null;
  hasMorePages: boolean;
  lastItem?: number | null;
  lastPage: number;
  perPage: number;
  total: number;
};

export type CountryInfoFragment = {
  __typename?: 'Country';
  country_code?: string | null;
  country_currency_code?: string | null;
  country_id?: number | null;
  country_international_code?: string | null;
  country_name?: string | null;
  is_deleted?: number | null;
};

export type StateInfoFragment = {
  __typename?: 'State';
  is_deleted?: number | null;
  state_id?: number | null;
  state_name?: string | null;
};

export type CityInfoFragment = {
  __typename?: 'City';
  city_id: number;
  city_name: string;
  is_deleted?: number | null;
};

export type MerchantCustomerFragment = {
  __typename?: 'MerchantCustomer';
  merchant_customer_id?: number | null;
  merchant_customer_company_name?: string | null;
  merchant_customer_registration_number?: string | null;
  merchant_customer_email?: string | null;
  full_address?: string | null;
  merchant_customer_phone_number?: string | null;
  merchant_customer_name?: string | null;
  merchant_customer_status?: Types.CustomerMerchantStatus | null;
  merchant_customer_created?: any | null;
  merchant_customer_address_1?: string | null;
  merchant_customer_address_2?: string | null;
  merchant_customer_postcode?: string | null;
  payment_link_transaction_total?: number | null;
  payment_link_transaction_count?: number | null;
  state?: {
    __typename?: 'State';
    state_id?: number | null;
    state_name?: string | null;
  } | null;
  country?: {
    __typename?: 'Country';
    country_id?: number | null;
    country_name?: string | null;
  } | null;
  city?: { __typename?: 'City'; city_id: number; city_name: string } | null;
};

export type PaymentLinkFragment = {
  __typename?: 'PaymentLink';
  payment_id?: number | null;
  payment_amount?: number | null;
  payment_amount_total?: number | null;
  payment_referer_code?: string | null;
  payment_extra_charges_rate?: number | null;
  payment_extra_charges_type?: string | null;
  payment_link?: string | null;
  payment_expired_date?: any | null;
  payment_created?: any | null;
  payment_reference?: string | null;
  payment_grandtotal?: number | null;
  payment_extra_charges_total?: number | null;
  payment_extra_charges?: number | null;
  paid_by?: Types.PaymentLinkPaidBy | null;
  payment_status?: {
    __typename?: 'PaymentStatus';
    payment_status_name?: string | null;
  } | null;
  merchant_customer?: {
    __typename?: 'MerchantCustomer';
    merchant_customer_name?: string | null;
    merchant_customer_company_name?: string | null;
    merchant_customer_registration_number?: string | null;
  } | null;
  customer?: {
    __typename?: 'Customer';
    customer_name?: string | null;
    customer_registration_number?: string | null;
    customer_bank_account_name?: string | null;
    customer_bank_account_number?: string | null;
    bank?: { __typename?: 'Bank'; bank_name?: string | null } | null;
  } | null;
  payment_log?: Array<{
    __typename?: 'PaymentLog';
    payment_log_action?: string | null;
    payment_log_description?: string | null;
    payment_log_remark?: string | null;
    payment_log_created?: any | null;
    user?: { __typename?: 'User'; user_fullname?: string | null } | null;
  } | null> | null;
};

export type PaymentCalculationFragment = {
  __typename?: 'PaymentCalculation';
  payment_subtotal?: number | null;
  payment_amount?: number | null;
  payment_standard_fee_rate?: number | null;
  payment_extra_charges_rate?: number | null;
  payment_extra_charges?: number | null;
  payment_grandtotal?: number | null;
};

export type PaymentMakeFragment = {
  __typename?: 'PaymentMake';
  payment_url?: string | null;
  payment_number?: string | null;
  payment?: {
    __typename?: 'Payment';
    payment_subtotal?: number | null;
    payment_extra_charges_rate?: number | null;
    payment_extra_charges?: number | null;
    payment_amount?: number | null;
    payment_referer_code?: string | null;
    payment_reference?: string | null;
    payment_type?: {
      __typename?: 'PaymentType';
      payment_type_name?: any | null;
    } | null;
    payment_repeat_type?: {
      __typename?: 'PaymentRepeatType';
      payment_repeat_type_name?: any | null;
    } | null;
    payment_schedule?: Array<{
      __typename?: 'PaymentSchedule';
      payment_schedule_date?: any | null;
    } | null> | null;
    payment_recipient?: Array<{
      __typename?: 'PaymentRecipientDetails';
      payment_recipient_account_name?: string | null;
      payment_recipient_account_number?: string | null;
      recipient?: {
        __typename?: 'Recipient';
        bank?: { __typename?: 'Bank'; bank_name?: string | null } | null;
      } | null;
    } | null> | null;
  } | null;
};

export const SuccessResponseFragmentDoc = gql`
  fragment SuccessResponse on SuccessResponse {
    status
    message
    data
  }
`;
export const TokenResponseFragmentDoc = gql`
  fragment TokenResponse on TokenResponse {
    token
    token_type
  }
`;
export const UserBasicInfoFragmentDoc = gql`
  fragment UserBasicInfo on User {
    user_id
    username
    user_email
    user_alternative_email
    user_fullname
    user_nric
    user_gender
    user_address
    user_address2
    user_postcode
    user_dob
    user_status
    user_logindate
    user_ip
    is_deleted
    user_mobile
    user_alternative_mobile
    user_mobile_verified
    user_join_date
    email_verified_at
    user_code
    user_created
    user_updated
    user_language
  }
`;
export const CountryInfoFragmentDoc = gql`
  fragment CountryInfo on Country {
    country_code
    country_currency_code
    country_id
    country_international_code
    country_name
    is_deleted
  }
`;
export const CityInfoFragmentDoc = gql`
  fragment CityInfo on City {
    city_id
    city_name
    is_deleted
  }
`;
export const StateInfoFragmentDoc = gql`
  fragment StateInfo on State {
    is_deleted
    state_id
    state_name
  }
`;
export const UserTypeInfoFragmentDoc = gql`
  fragment UserTypeInfo on UserType {
    user_type_id
    user_type_name
    user_type_slug
    user_type_group
  }
`;
export const UserRoleInfoFragmentDoc = gql`
  fragment UserRoleInfo on Role {
    id
    name
  }
`;
export const UserPermissionInfoFragmentDoc = gql`
  fragment UserPermissionInfo on Permission {
    id
    name
    group_name
    display_name
  }
`;
export const ImageInfoFragmentDoc = gql`
  fragment ImageInfo on Images {
    media_id
    full
    thumb
  }
`;
export const CustomerBasicInfoFragmentDoc = gql`
  fragment CustomerBasicInfo on Customer {
    customer_id
    customer_registration_number
    customer_type
    customer_name
    customer_website
    customer_address
    customer_postcode
    customer_address2
    customer_mobile
    customer_fax
    customer_email
    city {
      city_id
      city_name
    }
    state {
      state_id
      state_name
    }
    country {
      country_id
      country_name
    }
    setting_annual_revenue {
      setting_annual_revenue_id
      setting_annual_revenue_name
    }
    setting_company_size {
      setting_company_size_id
      setting_company_size_name
    }
    customer_question {
      customer_question_id
      customer_question_title
      customer_question_value
      customer_question_created
      question {
        question_title
        question_value
        question_id
      }
    }
    ssm_business_certificate {
      id
      url
      full_url
      file_name
      mime_type
    }
    reject_reason {
      reject_reason_name
      reject_reason_id
    }
    reject_reason_remark
    business_year {
      year_of_business_id
      year_of_business_name
    }
    business_type {
      business_type_id
      business_type_name
    }
    customer_contact_person
    customer_contact_person_mobile
    customer_status
    customer_remark
    customer_created
    customer_updated
    is_deleted
    bank {
      bank_id
      bank_name
    }
    customer_bank_account_name
    customer_bank_account_number
  }
`;
export const UserInfoFragmentDoc = gql`
  fragment UserInfo on User {
    ...UserBasicInfo
    user_nationality {
      ...CountryInfo
    }
    user_city {
      ...CityInfo
    }
    user_state {
      ...StateInfo
    }
    user_type {
      ...UserTypeInfo
    }
    user_role {
      ...UserRoleInfo
    }
    user_permissions {
      ...UserPermissionInfo
    }
    user_profile_image {
      ...ImageInfo
    }
    customer {
      ...CustomerBasicInfo
    }
  }
  ${UserBasicInfoFragmentDoc}
  ${CountryInfoFragmentDoc}
  ${CityInfoFragmentDoc}
  ${StateInfoFragmentDoc}
  ${UserTypeInfoFragmentDoc}
  ${UserRoleInfoFragmentDoc}
  ${UserPermissionInfoFragmentDoc}
  ${ImageInfoFragmentDoc}
  ${CustomerBasicInfoFragmentDoc}
`;
export const QuestionTypeInfoFragmentDoc = gql`
  fragment QuestionTypeInfo on Question {
    question_id
    question_title
    question_value
    question_priority
    question_section
    question_status
    question_type
    question_value_column
  }
`;
export const CustomerQuestionTypeInfoFragmentDoc = gql`
  fragment CustomerQuestionTypeInfo on CustomerQuestion {
    customer_question_id
    question {
      ...QuestionTypeInfo
    }
    customer_question_title
    customer_question_value
    customer_question_created
  }
  ${QuestionTypeInfoFragmentDoc}
`;
export const CustomerTypeInfoFragmentDoc = gql`
  fragment CustomerTypeInfo on Customer {
    ...CustomerBasicInfo
    city {
      ...CityInfo
    }
    state {
      ...StateInfo
    }
    country {
      ...CountryInfo
    }
    customer_question {
      ...CustomerQuestionTypeInfo
    }
  }
  ${CustomerBasicInfoFragmentDoc}
  ${CityInfoFragmentDoc}
  ${StateInfoFragmentDoc}
  ${CountryInfoFragmentDoc}
  ${CustomerQuestionTypeInfoFragmentDoc}
`;
export const PaginatorInfoFragmentDoc = gql`
  fragment PaginatorInfo on PaginatorInfo {
    count
    currentPage
    firstItem
    hasMorePages
    lastItem
    lastPage
    perPage
    total
  }
`;
export const MerchantCustomerFragmentDoc = gql`
  fragment MerchantCustomer on MerchantCustomer {
    merchant_customer_id
    merchant_customer_company_name
    merchant_customer_registration_number
    merchant_customer_email
    full_address
    merchant_customer_phone_number
    merchant_customer_name
    merchant_customer_status
    merchant_customer_created
    merchant_customer_address_1
    merchant_customer_address_2
    merchant_customer_postcode
    payment_link_transaction_total
    payment_link_transaction_count
    state {
      state_id
      state_name
    }
    country {
      country_id
      country_name
    }
    city {
      city_id
      city_name
    }
  }
`;
export const PaymentLinkFragmentDoc = gql`
  fragment PaymentLink on PaymentLink {
    payment_id
    payment_amount
    payment_amount_total
    payment_referer_code
    payment_extra_charges_rate
    payment_extra_charges_type
    payment_link
    payment_expired_date
    payment_created
    payment_reference
    payment_grandtotal
    payment_extra_charges_total
    payment_extra_charges
    paid_by
    payment_status {
      payment_status_name
    }
    merchant_customer {
      merchant_customer_name
      merchant_customer_company_name
      merchant_customer_registration_number
    }
    customer {
      customer_name
      customer_registration_number
      customer_bank_account_name
      customer_bank_account_number
      bank {
        bank_name
      }
    }
    payment_log {
      payment_log_action
      payment_log_description
      payment_log_remark
      payment_log_created
      user {
        user_fullname
      }
    }
  }
`;
export const PaymentCalculationFragmentDoc = gql`
  fragment PaymentCalculation on PaymentCalculation {
    payment_subtotal
    payment_amount
    payment_standard_fee_rate
    payment_extra_charges_rate
    payment_extra_charges
    payment_grandtotal
  }
`;
export const PaymentMakeFragmentDoc = gql`
  fragment PaymentMake on PaymentMake {
    payment_url
    payment_number
    payment {
      payment_subtotal
      payment_extra_charges_rate
      payment_extra_charges
      payment_amount
      payment_referer_code
      payment_reference
      payment_type {
        payment_type_name
      }
      payment_repeat_type {
        payment_repeat_type_name
      }
      payment_schedule {
        payment_schedule_date
      }
      payment_recipient {
        payment_recipient_account_name
        payment_recipient_account_number
        recipient {
          bank {
            bank_name
          }
        }
      }
    }
  }
`;
export const LoginDocument = gql`
  mutation Login($input: LoginInput) {
    Login(input: $input) {
      status
      message
      TokenResponse {
        ...TokenResponse
      }
    }
  }
  ${TokenResponseFragmentDoc}
`;
export type LoginMutationFn = Apollo.MutationFunction<
  LoginMutation,
  LoginMutationVariables
>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginMutation,
    LoginMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginMutation, LoginMutationVariables>(
    LoginDocument,
    options
  );
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<
  LoginMutation,
  LoginMutationVariables
>;
export const SecureLoginDocument = gql`
  mutation SecureLogin($input: SecureLoginInput) {
    SecureLogin(input: $input) {
      status
      message
      TokenResponse {
        ...TokenResponse
      }
    }
  }
  ${TokenResponseFragmentDoc}
`;
export type SecureLoginMutationFn = Apollo.MutationFunction<
  SecureLoginMutation,
  SecureLoginMutationVariables
>;

/**
 * __useSecureLoginMutation__
 *
 * To run a mutation, you first call `useSecureLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSecureLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [secureLoginMutation, { data, loading, error }] = useSecureLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSecureLoginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SecureLoginMutation,
    SecureLoginMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SecureLoginMutation, SecureLoginMutationVariables>(
    SecureLoginDocument,
    options
  );
}
export type SecureLoginMutationHookResult = ReturnType<
  typeof useSecureLoginMutation
>;
export type SecureLoginMutationResult =
  Apollo.MutationResult<SecureLoginMutation>;
export type SecureLoginMutationOptions = Apollo.BaseMutationOptions<
  SecureLoginMutation,
  SecureLoginMutationVariables
>;
export const RequestOtpDocument = gql`
  mutation RequestOTP($input: UserOTPInput) {
    RequestOTP(input: $input) {
      status
      message
    }
  }
`;
export type RequestOtpMutationFn = Apollo.MutationFunction<
  RequestOtpMutation,
  RequestOtpMutationVariables
>;

/**
 * __useRequestOtpMutation__
 *
 * To run a mutation, you first call `useRequestOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestOtpMutation, { data, loading, error }] = useRequestOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestOtpMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RequestOtpMutation,
    RequestOtpMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RequestOtpMutation, RequestOtpMutationVariables>(
    RequestOtpDocument,
    options
  );
}
export type RequestOtpMutationHookResult = ReturnType<
  typeof useRequestOtpMutation
>;
export type RequestOtpMutationResult =
  Apollo.MutationResult<RequestOtpMutation>;
export type RequestOtpMutationOptions = Apollo.BaseMutationOptions<
  RequestOtpMutation,
  RequestOtpMutationVariables
>;
export const RegisterDocument = gql`
  mutation Register($input: RegisterInput) {
    Register(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type RegisterMutationFn = Apollo.MutationFunction<
  RegisterMutation,
  RegisterMutationVariables
>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RegisterMutation,
    RegisterMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(
    RegisterDocument,
    options
  );
}
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<
  RegisterMutation,
  RegisterMutationVariables
>;
export const ResetPasswordSendEmailDocument = gql`
  mutation ResetPasswordSendEmail($user_email: String!) {
    ResetPasswordSendEmail(user_email: $user_email) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type ResetPasswordSendEmailMutationFn = Apollo.MutationFunction<
  ResetPasswordSendEmailMutation,
  ResetPasswordSendEmailMutationVariables
>;

/**
 * __useResetPasswordSendEmailMutation__
 *
 * To run a mutation, you first call `useResetPasswordSendEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordSendEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordSendEmailMutation, { data, loading, error }] = useResetPasswordSendEmailMutation({
 *   variables: {
 *      user_email: // value for 'user_email'
 *   },
 * });
 */
export function useResetPasswordSendEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordSendEmailMutation,
    ResetPasswordSendEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetPasswordSendEmailMutation,
    ResetPasswordSendEmailMutationVariables
  >(ResetPasswordSendEmailDocument, options);
}
export type ResetPasswordSendEmailMutationHookResult = ReturnType<
  typeof useResetPasswordSendEmailMutation
>;
export type ResetPasswordSendEmailMutationResult =
  Apollo.MutationResult<ResetPasswordSendEmailMutation>;
export type ResetPasswordSendEmailMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordSendEmailMutation,
  ResetPasswordSendEmailMutationVariables
>;
export const ResetPasswordCheckDocument = gql`
  mutation ResetPasswordCheck($token: String) {
    ResetPasswordCheck(token: $token) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type ResetPasswordCheckMutationFn = Apollo.MutationFunction<
  ResetPasswordCheckMutation,
  ResetPasswordCheckMutationVariables
>;

/**
 * __useResetPasswordCheckMutation__
 *
 * To run a mutation, you first call `useResetPasswordCheckMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordCheckMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordCheckMutation, { data, loading, error }] = useResetPasswordCheckMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useResetPasswordCheckMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordCheckMutation,
    ResetPasswordCheckMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetPasswordCheckMutation,
    ResetPasswordCheckMutationVariables
  >(ResetPasswordCheckDocument, options);
}
export type ResetPasswordCheckMutationHookResult = ReturnType<
  typeof useResetPasswordCheckMutation
>;
export type ResetPasswordCheckMutationResult =
  Apollo.MutationResult<ResetPasswordCheckMutation>;
export type ResetPasswordCheckMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordCheckMutation,
  ResetPasswordCheckMutationVariables
>;
export const ResetPasswordDocument = gql`
  mutation ResetPassword($input: ResetPasswordInput) {
    ResetPassword(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type ResetPasswordMutationFn = Apollo.MutationFunction<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ResetPasswordMutation,
    ResetPasswordMutationVariables
  >(ResetPasswordDocument, options);
}
export type ResetPasswordMutationHookResult = ReturnType<
  typeof useResetPasswordMutation
>;
export type ResetPasswordMutationResult =
  Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const LogoutDocument = gql`
  mutation Logout {
    Logout {
      status
      message
      data
    }
  }
`;
export type LogoutMutationFn = Apollo.MutationFunction<
  LogoutMutation,
  LogoutMutationVariables
>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LogoutMutation,
    LogoutMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(
    LogoutDocument,
    options
  );
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<
  LogoutMutation,
  LogoutMutationVariables
>;
export const QuestionListingDocument = gql`
  query QuestionListing($input: QuestionListingInput) {
    QuestionListing(input: $input) {
      data {
        ...QuestionTypeInfo
      }
      paginatorInfo {
        ...PaginatorInfo
      }
    }
  }
  ${QuestionTypeInfoFragmentDoc}
  ${PaginatorInfoFragmentDoc}
`;

/**
 * __useQuestionListingQuery__
 *
 * To run a query within a React component, call `useQuestionListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQuestionListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    QuestionListingQuery,
    QuestionListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<QuestionListingQuery, QuestionListingQueryVariables>(
    QuestionListingDocument,
    options
  );
}
export function useQuestionListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QuestionListingQuery,
    QuestionListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QuestionListingQuery,
    QuestionListingQueryVariables
  >(QuestionListingDocument, options);
}
export type QuestionListingQueryHookResult = ReturnType<
  typeof useQuestionListingQuery
>;
export type QuestionListingLazyQueryHookResult = ReturnType<
  typeof useQuestionListingLazyQuery
>;
export type QuestionListingQueryResult = Apollo.QueryResult<
  QuestionListingQuery,
  QuestionListingQueryVariables
>;
export const DashboardOverviewDocument = gql`
  query DashboardOverview($year: Int) {
    DashboardMerchant {
      status
      message
      data {
        payment_overview(year: $year) {
          payment_status_name
          total_amount
        }
      }
    }
  }
`;

/**
 * __useDashboardOverviewQuery__
 *
 * To run a query within a React component, call `useDashboardOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardOverviewQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useDashboardOverviewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DashboardOverviewQuery,
    DashboardOverviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DashboardOverviewQuery,
    DashboardOverviewQueryVariables
  >(DashboardOverviewDocument, options);
}
export function useDashboardOverviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardOverviewQuery,
    DashboardOverviewQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DashboardOverviewQuery,
    DashboardOverviewQueryVariables
  >(DashboardOverviewDocument, options);
}
export type DashboardOverviewQueryHookResult = ReturnType<
  typeof useDashboardOverviewQuery
>;
export type DashboardOverviewLazyQueryHookResult = ReturnType<
  typeof useDashboardOverviewLazyQuery
>;
export type DashboardOverviewQueryResult = Apollo.QueryResult<
  DashboardOverviewQuery,
  DashboardOverviewQueryVariables
>;
export const DashboardSpendingDocument = gql`
  query DashboardSpending($year: Int) {
    DashboardMerchant {
      status
      message
      data {
        spending_allocation(year: $year) {
          title
          data {
            payment_type_name
            amount
            count
            weightage
          }
        }
      }
    }
  }
`;

/**
 * __useDashboardSpendingQuery__
 *
 * To run a query within a React component, call `useDashboardSpendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardSpendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardSpendingQuery({
 *   variables: {
 *      year: // value for 'year'
 *   },
 * });
 */
export function useDashboardSpendingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DashboardSpendingQuery,
    DashboardSpendingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DashboardSpendingQuery,
    DashboardSpendingQueryVariables
  >(DashboardSpendingDocument, options);
}
export function useDashboardSpendingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardSpendingQuery,
    DashboardSpendingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DashboardSpendingQuery,
    DashboardSpendingQueryVariables
  >(DashboardSpendingDocument, options);
}
export type DashboardSpendingQueryHookResult = ReturnType<
  typeof useDashboardSpendingQuery
>;
export type DashboardSpendingLazyQueryHookResult = ReturnType<
  typeof useDashboardSpendingLazyQuery
>;
export type DashboardSpendingQueryResult = Apollo.QueryResult<
  DashboardSpendingQuery,
  DashboardSpendingQueryVariables
>;
export const DashboardUpcomingRecurringDocument = gql`
  query DashboardUpcomingRecurring {
    DashboardMerchant {
      status
      message
      data {
        upcoming_recurring_payment {
          payment_schedule_id
          payment {
            payment_schedule_total_number
            payment_recipient {
              payment_recipient_account_name
            }
          }
          payment_schedule_number
          payment_schedule_date
          payment_schedule_amount
        }
      }
    }
  }
`;

/**
 * __useDashboardUpcomingRecurringQuery__
 *
 * To run a query within a React component, call `useDashboardUpcomingRecurringQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardUpcomingRecurringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardUpcomingRecurringQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardUpcomingRecurringQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DashboardUpcomingRecurringQuery,
    DashboardUpcomingRecurringQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DashboardUpcomingRecurringQuery,
    DashboardUpcomingRecurringQueryVariables
  >(DashboardUpcomingRecurringDocument, options);
}
export function useDashboardUpcomingRecurringLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardUpcomingRecurringQuery,
    DashboardUpcomingRecurringQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DashboardUpcomingRecurringQuery,
    DashboardUpcomingRecurringQueryVariables
  >(DashboardUpcomingRecurringDocument, options);
}
export type DashboardUpcomingRecurringQueryHookResult = ReturnType<
  typeof useDashboardUpcomingRecurringQuery
>;
export type DashboardUpcomingRecurringLazyQueryHookResult = ReturnType<
  typeof useDashboardUpcomingRecurringLazyQuery
>;
export type DashboardUpcomingRecurringQueryResult = Apollo.QueryResult<
  DashboardUpcomingRecurringQuery,
  DashboardUpcomingRecurringQueryVariables
>;
export const DashboardPaymentListingDocument = gql`
  query DashboardPaymentListing($first: Int, $page: Int) {
    DashboardMerchant {
      status
      message
      data {
        payment_listing(first: $first, page: $page) {
          paginatorInfo {
            ...PaginatorInfo
          }
          data {
            payment_id
            payment_recipient {
              payment_recipient_account_name
              payment_recipient_id
            }
            payment_referer_code
            payment_end_date
            payment_status {
              payment_status_name
            }
          }
        }
      }
    }
  }
  ${PaginatorInfoFragmentDoc}
`;

/**
 * __useDashboardPaymentListingQuery__
 *
 * To run a query within a React component, call `useDashboardPaymentListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPaymentListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardPaymentListingQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDashboardPaymentListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    DashboardPaymentListingQuery,
    DashboardPaymentListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    DashboardPaymentListingQuery,
    DashboardPaymentListingQueryVariables
  >(DashboardPaymentListingDocument, options);
}
export function useDashboardPaymentListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    DashboardPaymentListingQuery,
    DashboardPaymentListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    DashboardPaymentListingQuery,
    DashboardPaymentListingQueryVariables
  >(DashboardPaymentListingDocument, options);
}
export type DashboardPaymentListingQueryHookResult = ReturnType<
  typeof useDashboardPaymentListingQuery
>;
export type DashboardPaymentListingLazyQueryHookResult = ReturnType<
  typeof useDashboardPaymentListingLazyQuery
>;
export type DashboardPaymentListingQueryResult = Apollo.QueryResult<
  DashboardPaymentListingQuery,
  DashboardPaymentListingQueryVariables
>;
export const MeDocument = gql`
  query Me {
    Me {
      ...UserInfo
    }
  }
  ${UserInfoFragmentDoc}
`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(
  baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export function useMeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const UserUpdateDocument = gql`
  mutation UserUpdate($input: UserUpdateInput) {
    UserUpdate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type UserUpdateMutationFn = Apollo.MutationFunction<
  UserUpdateMutation,
  UserUpdateMutationVariables
>;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserUpdateMutation,
    UserUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(
    UserUpdateDocument,
    options
  );
}
export type UserUpdateMutationHookResult = ReturnType<
  typeof useUserUpdateMutation
>;
export type UserUpdateMutationResult =
  Apollo.MutationResult<UserUpdateMutation>;
export type UserUpdateMutationOptions = Apollo.BaseMutationOptions<
  UserUpdateMutation,
  UserUpdateMutationVariables
>;
export const UserUpdatePasswordDocument = gql`
  mutation UserUpdatePassword($input: UserUpdatePasswordInput) {
    UserUpdatePassword(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type UserUpdatePasswordMutationFn = Apollo.MutationFunction<
  UserUpdatePasswordMutation,
  UserUpdatePasswordMutationVariables
>;

/**
 * __useUserUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUserUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdatePasswordMutation, { data, loading, error }] = useUserUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserUpdatePasswordMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserUpdatePasswordMutation,
    UserUpdatePasswordMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserUpdatePasswordMutation,
    UserUpdatePasswordMutationVariables
  >(UserUpdatePasswordDocument, options);
}
export type UserUpdatePasswordMutationHookResult = ReturnType<
  typeof useUserUpdatePasswordMutation
>;
export type UserUpdatePasswordMutationResult =
  Apollo.MutationResult<UserUpdatePasswordMutation>;
export type UserUpdatePasswordMutationOptions = Apollo.BaseMutationOptions<
  UserUpdatePasswordMutation,
  UserUpdatePasswordMutationVariables
>;
export const CustomerUpdateDocument = gql`
  mutation CustomerUpdate($input: CustomerUpdateInput) {
    CustomerUpdate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type CustomerUpdateMutationFn = Apollo.MutationFunction<
  CustomerUpdateMutation,
  CustomerUpdateMutationVariables
>;

/**
 * __useCustomerUpdateMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateMutation, { data, loading, error }] = useCustomerUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerUpdateMutation,
    CustomerUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerUpdateMutation,
    CustomerUpdateMutationVariables
  >(CustomerUpdateDocument, options);
}
export type CustomerUpdateMutationHookResult = ReturnType<
  typeof useCustomerUpdateMutation
>;
export type CustomerUpdateMutationResult =
  Apollo.MutationResult<CustomerUpdateMutation>;
export type CustomerUpdateMutationOptions = Apollo.BaseMutationOptions<
  CustomerUpdateMutation,
  CustomerUpdateMutationVariables
>;
export const SettingDetailsDocument = gql`
  query SettingDetails($input: [String!]!) {
    SettingDetails(setting_slugs: $input)
  }
`;

/**
 * __useSettingDetailsQuery__
 *
 * To run a query within a React component, call `useSettingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingDetailsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettingDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SettingDetailsQuery,
    SettingDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SettingDetailsQuery, SettingDetailsQueryVariables>(
    SettingDetailsDocument,
    options
  );
}
export function useSettingDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SettingDetailsQuery,
    SettingDetailsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SettingDetailsQuery, SettingDetailsQueryVariables>(
    SettingDetailsDocument,
    options
  );
}
export type SettingDetailsQueryHookResult = ReturnType<
  typeof useSettingDetailsQuery
>;
export type SettingDetailsLazyQueryHookResult = ReturnType<
  typeof useSettingDetailsLazyQuery
>;
export type SettingDetailsQueryResult = Apollo.QueryResult<
  SettingDetailsQuery,
  SettingDetailsQueryVariables
>;
export const SettingDetailDocument = gql`
  query SettingDetail($input: String!) {
    SettingDetail(setting_slug: $input) {
      setting_id
      setting_value
      setting_media {
        url
      }
    }
  }
`;

/**
 * __useSettingDetailQuery__
 *
 * To run a query within a React component, call `useSettingDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSettingDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSettingDetailQuery(
  baseOptions: Apollo.QueryHookOptions<
    SettingDetailQuery,
    SettingDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SettingDetailQuery, SettingDetailQueryVariables>(
    SettingDetailDocument,
    options
  );
}
export function useSettingDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SettingDetailQuery,
    SettingDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SettingDetailQuery, SettingDetailQueryVariables>(
    SettingDetailDocument,
    options
  );
}
export type SettingDetailQueryHookResult = ReturnType<
  typeof useSettingDetailQuery
>;
export type SettingDetailLazyQueryHookResult = ReturnType<
  typeof useSettingDetailLazyQuery
>;
export type SettingDetailQueryResult = Apollo.QueryResult<
  SettingDetailQuery,
  SettingDetailQueryVariables
>;
export const CustomerProfileUpdateDocument = gql`
  mutation CustomerProfileUpdate($input: CustomerProfileUpdateInput) {
    CustomerProfileUpdate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type CustomerProfileUpdateMutationFn = Apollo.MutationFunction<
  CustomerProfileUpdateMutation,
  CustomerProfileUpdateMutationVariables
>;

/**
 * __useCustomerProfileUpdateMutation__
 *
 * To run a mutation, you first call `useCustomerProfileUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerProfileUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerProfileUpdateMutation, { data, loading, error }] = useCustomerProfileUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerProfileUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerProfileUpdateMutation,
    CustomerProfileUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerProfileUpdateMutation,
    CustomerProfileUpdateMutationVariables
  >(CustomerProfileUpdateDocument, options);
}
export type CustomerProfileUpdateMutationHookResult = ReturnType<
  typeof useCustomerProfileUpdateMutation
>;
export type CustomerProfileUpdateMutationResult =
  Apollo.MutationResult<CustomerProfileUpdateMutation>;
export type CustomerProfileUpdateMutationOptions = Apollo.BaseMutationOptions<
  CustomerProfileUpdateMutation,
  CustomerProfileUpdateMutationVariables
>;
export const CustomerCreateDocument = gql`
  mutation CustomerCreate($input: CustomerCreateInput) {
    CustomerCreate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type CustomerCreateMutationFn = Apollo.MutationFunction<
  CustomerCreateMutation,
  CustomerCreateMutationVariables
>;

/**
 * __useCustomerCreateMutation__
 *
 * To run a mutation, you first call `useCustomerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerCreateMutation, { data, loading, error }] = useCustomerCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerCreateMutation,
    CustomerCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerCreateMutation,
    CustomerCreateMutationVariables
  >(CustomerCreateDocument, options);
}
export type CustomerCreateMutationHookResult = ReturnType<
  typeof useCustomerCreateMutation
>;
export type CustomerCreateMutationResult =
  Apollo.MutationResult<CustomerCreateMutation>;
export type CustomerCreateMutationOptions = Apollo.BaseMutationOptions<
  CustomerCreateMutation,
  CustomerCreateMutationVariables
>;
export const CustomerBankAccountUpdateDocument = gql`
  mutation CustomerBankAccountUpdate($input: CustomerBankAccountUpdateInput) {
    CustomerBankAccountUpdate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type CustomerBankAccountUpdateMutationFn = Apollo.MutationFunction<
  CustomerBankAccountUpdateMutation,
  CustomerBankAccountUpdateMutationVariables
>;

/**
 * __useCustomerBankAccountUpdateMutation__
 *
 * To run a mutation, you first call `useCustomerBankAccountUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerBankAccountUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerBankAccountUpdateMutation, { data, loading, error }] = useCustomerBankAccountUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerBankAccountUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerBankAccountUpdateMutation,
    CustomerBankAccountUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CustomerBankAccountUpdateMutation,
    CustomerBankAccountUpdateMutationVariables
  >(CustomerBankAccountUpdateDocument, options);
}
export type CustomerBankAccountUpdateMutationHookResult = ReturnType<
  typeof useCustomerBankAccountUpdateMutation
>;
export type CustomerBankAccountUpdateMutationResult =
  Apollo.MutationResult<CustomerBankAccountUpdateMutation>;
export type CustomerBankAccountUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    CustomerBankAccountUpdateMutation,
    CustomerBankAccountUpdateMutationVariables
  >;
export const CountryDropdownDocument = gql`
  query CountryDropdown {
    CountryDropdown {
      ...CountryInfo
    }
  }
  ${CountryInfoFragmentDoc}
`;

/**
 * __useCountryDropdownQuery__
 *
 * To run a query within a React component, call `useCountryDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountryDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountryDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useCountryDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CountryDropdownQuery,
    CountryDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CountryDropdownQuery, CountryDropdownQueryVariables>(
    CountryDropdownDocument,
    options
  );
}
export function useCountryDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CountryDropdownQuery,
    CountryDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CountryDropdownQuery,
    CountryDropdownQueryVariables
  >(CountryDropdownDocument, options);
}
export type CountryDropdownQueryHookResult = ReturnType<
  typeof useCountryDropdownQuery
>;
export type CountryDropdownLazyQueryHookResult = ReturnType<
  typeof useCountryDropdownLazyQuery
>;
export type CountryDropdownQueryResult = Apollo.QueryResult<
  CountryDropdownQuery,
  CountryDropdownQueryVariables
>;
export const StateDropdownDocument = gql`
  query StateDropdown($input: Int!) {
    StateDropdown(country_id: $input) {
      ...StateInfo
    }
  }
  ${StateInfoFragmentDoc}
`;

/**
 * __useStateDropdownQuery__
 *
 * To run a query within a React component, call `useStateDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useStateDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStateDropdownQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStateDropdownQuery(
  baseOptions: Apollo.QueryHookOptions<
    StateDropdownQuery,
    StateDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<StateDropdownQuery, StateDropdownQueryVariables>(
    StateDropdownDocument,
    options
  );
}
export function useStateDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StateDropdownQuery,
    StateDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<StateDropdownQuery, StateDropdownQueryVariables>(
    StateDropdownDocument,
    options
  );
}
export type StateDropdownQueryHookResult = ReturnType<
  typeof useStateDropdownQuery
>;
export type StateDropdownLazyQueryHookResult = ReturnType<
  typeof useStateDropdownLazyQuery
>;
export type StateDropdownQueryResult = Apollo.QueryResult<
  StateDropdownQuery,
  StateDropdownQueryVariables
>;
export const CityDropdownDocument = gql`
  query CityDropdown($input: Int) {
    CityDropdown(state_id: $input) {
      city_id
      city_name
      is_deleted
    }
  }
`;

/**
 * __useCityDropdownQuery__
 *
 * To run a query within a React component, call `useCityDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useCityDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCityDropdownQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCityDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CityDropdownQuery,
    CityDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CityDropdownQuery, CityDropdownQueryVariables>(
    CityDropdownDocument,
    options
  );
}
export function useCityDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CityDropdownQuery,
    CityDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CityDropdownQuery, CityDropdownQueryVariables>(
    CityDropdownDocument,
    options
  );
}
export type CityDropdownQueryHookResult = ReturnType<
  typeof useCityDropdownQuery
>;
export type CityDropdownLazyQueryHookResult = ReturnType<
  typeof useCityDropdownLazyQuery
>;
export type CityDropdownQueryResult = Apollo.QueryResult<
  CityDropdownQuery,
  CityDropdownQueryVariables
>;
export const PaymentGroupListingStatusCountDocument = gql`
  query PaymentGroupListingStatusCount($input: PaymentListingInput) {
    PaymentGroupListingStatusCount(input: $input) {
      payment_group_status
      count
    }
  }
`;

/**
 * __usePaymentGroupListingStatusCountQuery__
 *
 * To run a query within a React component, call `usePaymentGroupListingStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentGroupListingStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentGroupListingStatusCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentGroupListingStatusCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentGroupListingStatusCountQuery,
    PaymentGroupListingStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentGroupListingStatusCountQuery,
    PaymentGroupListingStatusCountQueryVariables
  >(PaymentGroupListingStatusCountDocument, options);
}
export function usePaymentGroupListingStatusCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentGroupListingStatusCountQuery,
    PaymentGroupListingStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentGroupListingStatusCountQuery,
    PaymentGroupListingStatusCountQueryVariables
  >(PaymentGroupListingStatusCountDocument, options);
}
export type PaymentGroupListingStatusCountQueryHookResult = ReturnType<
  typeof usePaymentGroupListingStatusCountQuery
>;
export type PaymentGroupListingStatusCountLazyQueryHookResult = ReturnType<
  typeof usePaymentGroupListingStatusCountLazyQuery
>;
export type PaymentGroupListingStatusCountQueryResult = Apollo.QueryResult<
  PaymentGroupListingStatusCountQuery,
  PaymentGroupListingStatusCountQueryVariables
>;
export const PaymentListingDocument = gql`
  query PaymentListing($input: PaymentListingInput, $first: Int, $page: Int) {
    PaymentListing(input: $input, first: $first, page: $page) {
      data {
        is_refund_requested
        is_payment_repeat
        is_repeated
        payment_amount
        payment_amount_total
        payment_complete_date
        payment_created
        payment_end_date
        payment_extra_charges
        payment_extra_charges_rate
        payment_extra_charges_total
        payment_grandtotal
        payment_id
        payment_reference
        payment_referer_code
        payment_schedule_number_current
        payment_schedule_total_number
        payment_start_date
        payment_subtotal
        payment_updated
        payment_complete_media {
          id
          collection_name
          name
          file_name
          mime_type
          url
          full_url
          path
          conversions
        }
        payment_status {
          payment_status_id
          payment_status_name
        }
        payment_type {
          payment_type_name
        }
        payment_schedule {
          is_refund_requested
          payment_schedule_id
          payment_schedule_amount
          payment_schedule_number
          payment_schedule_complete_date
          payment_schedule_created
          payment_schedule_date
          payment_schedule_referer_code
          payment_status {
            payment_status_id
            payment_status_name
          }
          payment {
            payment_amount
            payment_amount_total
            payment_complete_date
            payment_created
            payment_end_date
            payment_extra_charges
            payment_extra_charges_rate
            payment_extra_charges_total
            payment_grandtotal
            payment_id
            payment_reference
            payment_referer_code
            payment_schedule_number_current
            payment_schedule_total_number
            payment_start_date
            payment_subtotal
            payment_updated
            is_payment_repeat
            payment_recipient {
              payment_recipient_account_name
              payment_recipient_account_number
              payment_recipient_amount
            }
          }
          payment_repeat_type {
            payment_repeat_type_charges_rate
            payment_repeat_type_name
            is_extra_charges
          }
          user_card {
            user_id
            user_card_id
            user_card_cardholder_name
            user_card_expiration_month
            user_card_expiration_year
            user_card_last_4_digit
          }
          payment_schedule_complete_media {
            file_name
            url
            full_url
            mime_type
          }
        }
        user_card {
          user_id
          user_card_id
          user_card_cardholder_name
          user_card_expiration_month
          user_card_expiration_year
          user_card_last_4_digit
        }
        payment_recipient {
          payment_recipient_account_name
          payment_recipient_account_number
          payment_recipient_amount
          recipient {
            bank {
              bank_name
              bank_logo {
                thumb
              }
            }
          }
        }
        payment_repeat_type {
          payment_repeat_type_charges_rate
          payment_repeat_type_name
          is_extra_charges
        }
        payment_supporting_media {
          file_name
          url
          mime_type
        }
        payment_complete_media {
          file_name
          url
          mime_type
        }
      }
      paginatorInfo {
        ...PaginatorInfo
      }
    }
  }
  ${PaginatorInfoFragmentDoc}
`;

/**
 * __usePaymentListingQuery__
 *
 * To run a query within a React component, call `usePaymentListingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePaymentListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentListingQuery,
    PaymentListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaymentListingQuery, PaymentListingQueryVariables>(
    PaymentListingDocument,
    options
  );
}
export function usePaymentListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentListingQuery,
    PaymentListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PaymentListingQuery, PaymentListingQueryVariables>(
    PaymentListingDocument,
    options
  );
}
export type PaymentListingQueryHookResult = ReturnType<
  typeof usePaymentListingQuery
>;
export type PaymentListingLazyQueryHookResult = ReturnType<
  typeof usePaymentListingLazyQuery
>;
export type PaymentListingQueryResult = Apollo.QueryResult<
  PaymentListingQuery,
  PaymentListingQueryVariables
>;
export const PaymentDetailDocument = gql`
  query PaymentDetail($payment_id: Int) {
    PaymentDetail(payment_id: $payment_id) {
      is_payment_repeat
      is_repeated
      payment_amount
      payment_amount_total
      payment_complete_date
      payment_created
      payment_end_date
      payment_extra_charges
      payment_extra_charges_rate
      payment_extra_charges_total
      payment_grandtotal
      payment_id
      payment_reference
      payment_referer_code
      payment_schedule_number_current
      payment_schedule_total_number
      payment_start_date
      payment_subtotal
      payment_updated
      payment_reject_details {
        payment_log_remark
        reject_reason {
          reject_reason_name
          reject_reason_id
          reject_reason_description
          reject_reason_type
        }
      }
      payment_complete_media {
        id
        collection_name
        name
        file_name
        mime_type
        url
        full_url
        path
        conversions
      }
      payment_status {
        payment_status_id
        payment_status_name
      }
      payment_type {
        payment_type_name
      }
      payment_schedule {
        payment_schedule_id
        payment_schedule_amount
        payment_schedule_number
        payment_schedule_complete_date
        payment_schedule_created
        payment_schedule_date
        payment_schedule_referer_code
        payment_status {
          payment_status_id
          payment_status_name
        }
        payment {
          payment_amount
          payment_amount_total
          payment_complete_date
          payment_created
          payment_end_date
          payment_extra_charges
          payment_extra_charges_rate
          payment_extra_charges_total
          payment_grandtotal
          payment_id
          payment_reference
          payment_referer_code
          payment_schedule_number_current
          payment_schedule_total_number
          payment_start_date
          payment_subtotal
          payment_updated
          is_payment_repeat
          payment_recipient {
            payment_recipient_account_name
            payment_recipient_account_number
            payment_recipient_amount
          }
        }
        payment_repeat_type {
          payment_repeat_type_charges_rate
          payment_repeat_type_name
          is_extra_charges
        }
        user_card {
          user_id
          user_card_id
          user_card_cardholder_name
          user_card_expiration_month
          user_card_expiration_year
          user_card_last_4_digit
        }
        payment_schedule_complete_media {
          file_name
          url
          mime_type
        }
      }
      user_card {
        user_id
        user_card_id
        user_card_cardholder_name
        user_card_expiration_month
        user_card_expiration_year
        user_card_last_4_digit
      }
      payment_recipient {
        payment_recipient_account_name
        payment_recipient_account_number
        payment_recipient_amount
        recipient {
          bank {
            bank_name
            bank_logo {
              thumb
            }
          }
        }
      }
      payment_repeat_type {
        payment_repeat_type_charges_rate
        payment_repeat_type_name
        is_extra_charges
      }
      payment_supporting_media {
        file_name
        url
        mime_type
      }
    }
  }
`;

/**
 * __usePaymentDetailQuery__
 *
 * To run a query within a React component, call `usePaymentDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentDetailQuery({
 *   variables: {
 *      payment_id: // value for 'payment_id'
 *   },
 * });
 */
export function usePaymentDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentDetailQuery,
    PaymentDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaymentDetailQuery, PaymentDetailQueryVariables>(
    PaymentDetailDocument,
    options
  );
}
export function usePaymentDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentDetailQuery,
    PaymentDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PaymentDetailQuery, PaymentDetailQueryVariables>(
    PaymentDetailDocument,
    options
  );
}
export type PaymentDetailQueryHookResult = ReturnType<
  typeof usePaymentDetailQuery
>;
export type PaymentDetailLazyQueryHookResult = ReturnType<
  typeof usePaymentDetailLazyQuery
>;
export type PaymentDetailQueryResult = Apollo.QueryResult<
  PaymentDetailQuery,
  PaymentDetailQueryVariables
>;
export const PaymentCheckStatusDocument = gql`
  query PaymentCheckStatus($payment_id: Int) {
    PaymentDetail(payment_id: $payment_id) {
      payment_status {
        payment_status_id
        payment_status_name
      }
    }
  }
`;

/**
 * __usePaymentCheckStatusQuery__
 *
 * To run a query within a React component, call `usePaymentCheckStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentCheckStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentCheckStatusQuery({
 *   variables: {
 *      payment_id: // value for 'payment_id'
 *   },
 * });
 */
export function usePaymentCheckStatusQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentCheckStatusQuery,
    PaymentCheckStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentCheckStatusQuery,
    PaymentCheckStatusQueryVariables
  >(PaymentCheckStatusDocument, options);
}
export function usePaymentCheckStatusLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentCheckStatusQuery,
    PaymentCheckStatusQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentCheckStatusQuery,
    PaymentCheckStatusQueryVariables
  >(PaymentCheckStatusDocument, options);
}
export type PaymentCheckStatusQueryHookResult = ReturnType<
  typeof usePaymentCheckStatusQuery
>;
export type PaymentCheckStatusLazyQueryHookResult = ReturnType<
  typeof usePaymentCheckStatusLazyQuery
>;
export type PaymentCheckStatusQueryResult = Apollo.QueryResult<
  PaymentCheckStatusQuery,
  PaymentCheckStatusQueryVariables
>;
export const PaymentScheduleListingDocument = gql`
  query PaymentScheduleListing(
    $input: PaymentScheduleListingInput
    $first: Int
    $page: Int
  ) {
    PaymentScheduleListing(input: $input, first: $first, page: $page) {
      data {
        payment_schedule_id
        payment_schedule_log {
          payment_schedule_log_description
          payment_schedule_log_action
        }
        payment_schedule_referer_code
        payment_status {
          payment_status_id
          payment_status_name
        }
        payment_schedule_amount
        payment_schedule_number
        payment_schedule_complete_media {
          id
          collection_name
          name
          file_name
          mime_type
          url
          full_url
          path
          conversions
        }
        payment_schedule_complete_date
        payment_schedule_created
        payment_schedule_date
        payment_status {
          payment_status_id
          payment_status_name
        }
        customer {
          customer_id
          customer_name
          customer_contact_person
        }
        user_card {
          user_id
          user_card_id
          user_card_cardholder_name
          user_card_expiration_month
          user_card_expiration_year
          user_card_last_4_digit
        }
        payment {
          payment_schedule_total_number
          payment_amount_total
          payment_amount
          payment_id
          payment_reference
          is_payment_repeat
          payment_schedule {
            payment_schedule_referer_code
            payment_status {
              payment_status_id
              payment_status_name
            }
            payment_schedule_date
            payment_schedule_amount
            payment_schedule_number
          }
          payment_type {
            payment_type_name
          }
          payment_recipient {
            payment_recipient_account_name
            payment_recipient_account_number
            payment_recipient_amount
          }
        }
        payment_recipient {
          payment {
            payment_reference
          }
          payment_recipient_account_name
          payment_recipient_account_number
          payment_recipient_amount
          recipient {
            recipient_id
            recipient_category {
              recipient_category_name
            }
            recipient_bank_holder_name
            recipient_bank_account_number
            bank {
              bank_name
              bank_logo {
                thumb
              }
            }
            recipient_type
          }
        }
        payment_repeat_type {
          payment_repeat_type_charges_rate
          payment_repeat_type_name
          is_extra_charges
        }
        payment_schedule_complete_media {
          file_name
          url
          mime_type
        }
        payment_schedule_log {
          payment_schedule_log_action
          payment_schedule_log_description
          payment_schedule_log_created
          payment_schedule_log_updated
          admin {
            user_fullname
          }
        }
      }
      paginatorInfo {
        ...PaginatorInfo
      }
    }
  }
  ${PaginatorInfoFragmentDoc}
`;

/**
 * __usePaymentScheduleListingQuery__
 *
 * To run a query within a React component, call `usePaymentScheduleListingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentScheduleListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentScheduleListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePaymentScheduleListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentScheduleListingQuery,
    PaymentScheduleListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentScheduleListingQuery,
    PaymentScheduleListingQueryVariables
  >(PaymentScheduleListingDocument, options);
}
export function usePaymentScheduleListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentScheduleListingQuery,
    PaymentScheduleListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentScheduleListingQuery,
    PaymentScheduleListingQueryVariables
  >(PaymentScheduleListingDocument, options);
}
export type PaymentScheduleListingQueryHookResult = ReturnType<
  typeof usePaymentScheduleListingQuery
>;
export type PaymentScheduleListingLazyQueryHookResult = ReturnType<
  typeof usePaymentScheduleListingLazyQuery
>;
export type PaymentScheduleListingQueryResult = Apollo.QueryResult<
  PaymentScheduleListingQuery,
  PaymentScheduleListingQueryVariables
>;
export const PaymentTypeDropdownDocument = gql`
  query PaymentTypeDropdown {
    PaymentTypeDropdown {
      payment_type_id
      payment_type_name
      payment_type_document
      is_allowed_payment_repeat
    }
  }
`;

/**
 * __usePaymentTypeDropdownQuery__
 *
 * To run a query within a React component, call `usePaymentTypeDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentTypeDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentTypeDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentTypeDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentTypeDropdownQuery,
    PaymentTypeDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentTypeDropdownQuery,
    PaymentTypeDropdownQueryVariables
  >(PaymentTypeDropdownDocument, options);
}
export function usePaymentTypeDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentTypeDropdownQuery,
    PaymentTypeDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentTypeDropdownQuery,
    PaymentTypeDropdownQueryVariables
  >(PaymentTypeDropdownDocument, options);
}
export type PaymentTypeDropdownQueryHookResult = ReturnType<
  typeof usePaymentTypeDropdownQuery
>;
export type PaymentTypeDropdownLazyQueryHookResult = ReturnType<
  typeof usePaymentTypeDropdownLazyQuery
>;
export type PaymentTypeDropdownQueryResult = Apollo.QueryResult<
  PaymentTypeDropdownQuery,
  PaymentTypeDropdownQueryVariables
>;
export const PaymentStatusDropdownDocument = gql`
  query PaymentStatusDropdown {
    PaymentStatusDropdown {
      payment_status_id
      payment_status_name
      payment_status_desc
    }
  }
`;

/**
 * __usePaymentStatusDropdownQuery__
 *
 * To run a query within a React component, call `usePaymentStatusDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentStatusDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentStatusDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentStatusDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentStatusDropdownQuery,
    PaymentStatusDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentStatusDropdownQuery,
    PaymentStatusDropdownQueryVariables
  >(PaymentStatusDropdownDocument, options);
}
export function usePaymentStatusDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentStatusDropdownQuery,
    PaymentStatusDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentStatusDropdownQuery,
    PaymentStatusDropdownQueryVariables
  >(PaymentStatusDropdownDocument, options);
}
export type PaymentStatusDropdownQueryHookResult = ReturnType<
  typeof usePaymentStatusDropdownQuery
>;
export type PaymentStatusDropdownLazyQueryHookResult = ReturnType<
  typeof usePaymentStatusDropdownLazyQuery
>;
export type PaymentStatusDropdownQueryResult = Apollo.QueryResult<
  PaymentStatusDropdownQuery,
  PaymentStatusDropdownQueryVariables
>;
export const PaymentRepeatTypeDropdownDocument = gql`
  query PaymentRepeatTypeDropdown($input: PaymentRepeatTypeCategory) {
    PaymentRepeatTypeDropdown(payment_repeat_type_category: $input) {
      payment_repeat_type_id
      payment_repeat_type_name
      payment_repeat_type_charges_type
      payment_repeat_type_charges_rate
      payment_repeat_type_category
      payment_repeat_type_additional_days
      standard_fee
      is_extra_charges
    }
  }
`;

/**
 * __usePaymentRepeatTypeDropdownQuery__
 *
 * To run a query within a React component, call `usePaymentRepeatTypeDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentRepeatTypeDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentRepeatTypeDropdownQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentRepeatTypeDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentRepeatTypeDropdownQuery,
    PaymentRepeatTypeDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentRepeatTypeDropdownQuery,
    PaymentRepeatTypeDropdownQueryVariables
  >(PaymentRepeatTypeDropdownDocument, options);
}
export function usePaymentRepeatTypeDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentRepeatTypeDropdownQuery,
    PaymentRepeatTypeDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentRepeatTypeDropdownQuery,
    PaymentRepeatTypeDropdownQueryVariables
  >(PaymentRepeatTypeDropdownDocument, options);
}
export type PaymentRepeatTypeDropdownQueryHookResult = ReturnType<
  typeof usePaymentRepeatTypeDropdownQuery
>;
export type PaymentRepeatTypeDropdownLazyQueryHookResult = ReturnType<
  typeof usePaymentRepeatTypeDropdownLazyQuery
>;
export type PaymentRepeatTypeDropdownQueryResult = Apollo.QueryResult<
  PaymentRepeatTypeDropdownQuery,
  PaymentRepeatTypeDropdownQueryVariables
>;
export const PaymentListingExportDocument = gql`
  query PaymentListingExport($input: PaymentListingInput) {
    PaymentListingExport(input: $input) {
      status
      message
      data
    }
  }
`;

/**
 * __usePaymentListingExportQuery__
 *
 * To run a query within a React component, call `usePaymentListingExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentListingExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentListingExportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentListingExportQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentListingExportQuery,
    PaymentListingExportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentListingExportQuery,
    PaymentListingExportQueryVariables
  >(PaymentListingExportDocument, options);
}
export function usePaymentListingExportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentListingExportQuery,
    PaymentListingExportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentListingExportQuery,
    PaymentListingExportQueryVariables
  >(PaymentListingExportDocument, options);
}
export type PaymentListingExportQueryHookResult = ReturnType<
  typeof usePaymentListingExportQuery
>;
export type PaymentListingExportLazyQueryHookResult = ReturnType<
  typeof usePaymentListingExportLazyQuery
>;
export type PaymentListingExportQueryResult = Apollo.QueryResult<
  PaymentListingExportQuery,
  PaymentListingExportQueryVariables
>;
export const PaymentScheduleListingExportDocument = gql`
  query PaymentScheduleListingExport($input: PaymentScheduleListingInput) {
    PaymentScheduleListingExport(input: $input) {
      status
      message
      data
    }
  }
`;

/**
 * __usePaymentScheduleListingExportQuery__
 *
 * To run a query within a React component, call `usePaymentScheduleListingExportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentScheduleListingExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentScheduleListingExportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentScheduleListingExportQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentScheduleListingExportQuery,
    PaymentScheduleListingExportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentScheduleListingExportQuery,
    PaymentScheduleListingExportQueryVariables
  >(PaymentScheduleListingExportDocument, options);
}
export function usePaymentScheduleListingExportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentScheduleListingExportQuery,
    PaymentScheduleListingExportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentScheduleListingExportQuery,
    PaymentScheduleListingExportQueryVariables
  >(PaymentScheduleListingExportDocument, options);
}
export type PaymentScheduleListingExportQueryHookResult = ReturnType<
  typeof usePaymentScheduleListingExportQuery
>;
export type PaymentScheduleListingExportLazyQueryHookResult = ReturnType<
  typeof usePaymentScheduleListingExportLazyQuery
>;
export type PaymentScheduleListingExportQueryResult = Apollo.QueryResult<
  PaymentScheduleListingExportQuery,
  PaymentScheduleListingExportQueryVariables
>;
export const PaymentCreateDocument = gql`
  mutation PaymentCreate($input: PaymentCreateInput) {
    PaymentCreate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type PaymentCreateMutationFn = Apollo.MutationFunction<
  PaymentCreateMutation,
  PaymentCreateMutationVariables
>;

/**
 * __usePaymentCreateMutation__
 *
 * To run a mutation, you first call `usePaymentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentCreateMutation, { data, loading, error }] = usePaymentCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PaymentCreateMutation,
    PaymentCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PaymentCreateMutation,
    PaymentCreateMutationVariables
  >(PaymentCreateDocument, options);
}
export type PaymentCreateMutationHookResult = ReturnType<
  typeof usePaymentCreateMutation
>;
export type PaymentCreateMutationResult =
  Apollo.MutationResult<PaymentCreateMutation>;
export type PaymentCreateMutationOptions = Apollo.BaseMutationOptions<
  PaymentCreateMutation,
  PaymentCreateMutationVariables
>;
export const PaymentCancelDocument = gql`
  mutation PaymentCancel($input: Int) {
    PaymentCancel(payment_id: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type PaymentCancelMutationFn = Apollo.MutationFunction<
  PaymentCancelMutation,
  PaymentCancelMutationVariables
>;

/**
 * __usePaymentCancelMutation__
 *
 * To run a mutation, you first call `usePaymentCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentCancelMutation, { data, loading, error }] = usePaymentCancelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentCancelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PaymentCancelMutation,
    PaymentCancelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PaymentCancelMutation,
    PaymentCancelMutationVariables
  >(PaymentCancelDocument, options);
}
export type PaymentCancelMutationHookResult = ReturnType<
  typeof usePaymentCancelMutation
>;
export type PaymentCancelMutationResult =
  Apollo.MutationResult<PaymentCancelMutation>;
export type PaymentCancelMutationOptions = Apollo.BaseMutationOptions<
  PaymentCancelMutation,
  PaymentCancelMutationVariables
>;
export const PaymentScheduleCancelDocument = gql`
  mutation PaymentScheduleCancel($input: Int) {
    PaymentScheduleCancel(payment_schedule_id: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type PaymentScheduleCancelMutationFn = Apollo.MutationFunction<
  PaymentScheduleCancelMutation,
  PaymentScheduleCancelMutationVariables
>;

/**
 * __usePaymentScheduleCancelMutation__
 *
 * To run a mutation, you first call `usePaymentScheduleCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentScheduleCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentScheduleCancelMutation, { data, loading, error }] = usePaymentScheduleCancelMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentScheduleCancelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PaymentScheduleCancelMutation,
    PaymentScheduleCancelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PaymentScheduleCancelMutation,
    PaymentScheduleCancelMutationVariables
  >(PaymentScheduleCancelDocument, options);
}
export type PaymentScheduleCancelMutationHookResult = ReturnType<
  typeof usePaymentScheduleCancelMutation
>;
export type PaymentScheduleCancelMutationResult =
  Apollo.MutationResult<PaymentScheduleCancelMutation>;
export type PaymentScheduleCancelMutationOptions = Apollo.BaseMutationOptions<
  PaymentScheduleCancelMutation,
  PaymentScheduleCancelMutationVariables
>;
export const PaymentListingStatusCountDocument = gql`
  query PaymentListingStatusCount($input: PaymentListingInput) {
    PaymentListingStatusCount(input: $input) {
      payment_status_id
      payment_status_name
      count
    }
  }
`;

/**
 * __usePaymentListingStatusCountQuery__
 *
 * To run a query within a React component, call `usePaymentListingStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentListingStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentListingStatusCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentListingStatusCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentListingStatusCountQuery,
    PaymentListingStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentListingStatusCountQuery,
    PaymentListingStatusCountQueryVariables
  >(PaymentListingStatusCountDocument, options);
}
export function usePaymentListingStatusCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentListingStatusCountQuery,
    PaymentListingStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentListingStatusCountQuery,
    PaymentListingStatusCountQueryVariables
  >(PaymentListingStatusCountDocument, options);
}
export type PaymentListingStatusCountQueryHookResult = ReturnType<
  typeof usePaymentListingStatusCountQuery
>;
export type PaymentListingStatusCountLazyQueryHookResult = ReturnType<
  typeof usePaymentListingStatusCountLazyQuery
>;
export type PaymentListingStatusCountQueryResult = Apollo.QueryResult<
  PaymentListingStatusCountQuery,
  PaymentListingStatusCountQueryVariables
>;
export const PaymentMakeDocument = gql`
  query PaymentMake($payment_id: Int) {
    PaymentMake(payment_id: $payment_id) {
      ...PaymentMake
    }
  }
  ${PaymentMakeFragmentDoc}
`;

/**
 * __usePaymentMakeQuery__
 *
 * To run a query within a React component, call `usePaymentMakeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMakeQuery({
 *   variables: {
 *      payment_id: // value for 'payment_id'
 *   },
 * });
 */
export function usePaymentMakeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentMakeQuery,
    PaymentMakeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaymentMakeQuery, PaymentMakeQueryVariables>(
    PaymentMakeDocument,
    options
  );
}
export function usePaymentMakeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentMakeQuery,
    PaymentMakeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PaymentMakeQuery, PaymentMakeQueryVariables>(
    PaymentMakeDocument,
    options
  );
}
export type PaymentMakeQueryHookResult = ReturnType<typeof usePaymentMakeQuery>;
export type PaymentMakeLazyQueryHookResult = ReturnType<
  typeof usePaymentMakeLazyQuery
>;
export type PaymentMakeQueryResult = Apollo.QueryResult<
  PaymentMakeQuery,
  PaymentMakeQueryVariables
>;
export const PaymentRefundDocument = gql`
  mutation PaymentRefund($input: PaymentRefundInput) {
    PaymentRefund(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type PaymentRefundMutationFn = Apollo.MutationFunction<
  PaymentRefundMutation,
  PaymentRefundMutationVariables
>;

/**
 * __usePaymentRefundMutation__
 *
 * To run a mutation, you first call `usePaymentRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentRefundMutation, { data, loading, error }] = usePaymentRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentRefundMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PaymentRefundMutation,
    PaymentRefundMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PaymentRefundMutation,
    PaymentRefundMutationVariables
  >(PaymentRefundDocument, options);
}
export type PaymentRefundMutationHookResult = ReturnType<
  typeof usePaymentRefundMutation
>;
export type PaymentRefundMutationResult =
  Apollo.MutationResult<PaymentRefundMutation>;
export type PaymentRefundMutationOptions = Apollo.BaseMutationOptions<
  PaymentRefundMutation,
  PaymentRefundMutationVariables
>;
export const PaymentScheduleRefundDocument = gql`
  mutation PaymentScheduleRefund($input: PaymentScheduleRefundInput) {
    PaymentScheduleRefund(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type PaymentScheduleRefundMutationFn = Apollo.MutationFunction<
  PaymentScheduleRefundMutation,
  PaymentScheduleRefundMutationVariables
>;

/**
 * __usePaymentScheduleRefundMutation__
 *
 * To run a mutation, you first call `usePaymentScheduleRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentScheduleRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentScheduleRefundMutation, { data, loading, error }] = usePaymentScheduleRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentScheduleRefundMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PaymentScheduleRefundMutation,
    PaymentScheduleRefundMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PaymentScheduleRefundMutation,
    PaymentScheduleRefundMutationVariables
  >(PaymentScheduleRefundDocument, options);
}
export type PaymentScheduleRefundMutationHookResult = ReturnType<
  typeof usePaymentScheduleRefundMutation
>;
export type PaymentScheduleRefundMutationResult =
  Apollo.MutationResult<PaymentScheduleRefundMutation>;
export type PaymentScheduleRefundMutationOptions = Apollo.BaseMutationOptions<
  PaymentScheduleRefundMutation,
  PaymentScheduleRefundMutationVariables
>;
export const PaymentScheduleMakeDocument = gql`
  mutation PaymentScheduleMake($input: Int) {
    PaymentScheduleMake(payment_schedule_id: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type PaymentScheduleMakeMutationFn = Apollo.MutationFunction<
  PaymentScheduleMakeMutation,
  PaymentScheduleMakeMutationVariables
>;

/**
 * __usePaymentScheduleMakeMutation__
 *
 * To run a mutation, you first call `usePaymentScheduleMakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentScheduleMakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentScheduleMakeMutation, { data, loading, error }] = usePaymentScheduleMakeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentScheduleMakeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PaymentScheduleMakeMutation,
    PaymentScheduleMakeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PaymentScheduleMakeMutation,
    PaymentScheduleMakeMutationVariables
  >(PaymentScheduleMakeDocument, options);
}
export type PaymentScheduleMakeMutationHookResult = ReturnType<
  typeof usePaymentScheduleMakeMutation
>;
export type PaymentScheduleMakeMutationResult =
  Apollo.MutationResult<PaymentScheduleMakeMutation>;
export type PaymentScheduleMakeMutationOptions = Apollo.BaseMutationOptions<
  PaymentScheduleMakeMutation,
  PaymentScheduleMakeMutationVariables
>;
export const UserCardListingDocument = gql`
  query UserCardListing($input: UserCardListingInput, $first: Int, $page: Int) {
    UserCardListing(input: $input, first: $first, page: $page) {
      data {
        is_default_card
        is_deleted
        user {
          user_id
          user_fullname
        }
        user_card_created
        user_card_expiration_month
        user_card_expiration_year
        user_card_id
        user_card_last_4_digit
        user_card_status
        user_card_updated
      }
      paginatorInfo {
        ...PaginatorInfo
      }
    }
  }
  ${PaginatorInfoFragmentDoc}
`;

/**
 * __useUserCardListingQuery__
 *
 * To run a query within a React component, call `useUserCardListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCardListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCardListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useUserCardListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserCardListingQuery,
    UserCardListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserCardListingQuery, UserCardListingQueryVariables>(
    UserCardListingDocument,
    options
  );
}
export function useUserCardListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserCardListingQuery,
    UserCardListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserCardListingQuery,
    UserCardListingQueryVariables
  >(UserCardListingDocument, options);
}
export type UserCardListingQueryHookResult = ReturnType<
  typeof useUserCardListingQuery
>;
export type UserCardListingLazyQueryHookResult = ReturnType<
  typeof useUserCardListingLazyQuery
>;
export type UserCardListingQueryResult = Apollo.QueryResult<
  UserCardListingQuery,
  UserCardListingQueryVariables
>;
export const UserCardDropdownDocument = gql`
  query UserCardDropdown {
    UserCardDropdown {
      user_card_id
      user_card_cardholder_name
      user_card_network_type
      user_card_expiration_month
      user_card_expiration_year
      user_card_last_4_digit
      user {
        user_fullname
      }
      is_default_card
    }
  }
`;

/**
 * __useUserCardDropdownQuery__
 *
 * To run a query within a React component, call `useUserCardDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserCardDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserCardDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserCardDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    UserCardDropdownQuery,
    UserCardDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<UserCardDropdownQuery, UserCardDropdownQueryVariables>(
    UserCardDropdownDocument,
    options
  );
}
export function useUserCardDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UserCardDropdownQuery,
    UserCardDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UserCardDropdownQuery,
    UserCardDropdownQueryVariables
  >(UserCardDropdownDocument, options);
}
export type UserCardDropdownQueryHookResult = ReturnType<
  typeof useUserCardDropdownQuery
>;
export type UserCardDropdownLazyQueryHookResult = ReturnType<
  typeof useUserCardDropdownLazyQuery
>;
export type UserCardDropdownQueryResult = Apollo.QueryResult<
  UserCardDropdownQuery,
  UserCardDropdownQueryVariables
>;
export const UserCardCreateDocument = gql`
  mutation UserCardCreate($input: UserCardCreateInput) {
    UserCardCreate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type UserCardCreateMutationFn = Apollo.MutationFunction<
  UserCardCreateMutation,
  UserCardCreateMutationVariables
>;

/**
 * __useUserCardCreateMutation__
 *
 * To run a mutation, you first call `useUserCardCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCardCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCardCreateMutation, { data, loading, error }] = useUserCardCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCardCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserCardCreateMutation,
    UserCardCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserCardCreateMutation,
    UserCardCreateMutationVariables
  >(UserCardCreateDocument, options);
}
export type UserCardCreateMutationHookResult = ReturnType<
  typeof useUserCardCreateMutation
>;
export type UserCardCreateMutationResult =
  Apollo.MutationResult<UserCardCreateMutation>;
export type UserCardCreateMutationOptions = Apollo.BaseMutationOptions<
  UserCardCreateMutation,
  UserCardCreateMutationVariables
>;
export const UserCardUpdateDefaultDocument = gql`
  mutation UserCardUpdateDefault($input: UserCardUpdateDefaultInput) {
    UserCardUpdateDefault(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type UserCardUpdateDefaultMutationFn = Apollo.MutationFunction<
  UserCardUpdateDefaultMutation,
  UserCardUpdateDefaultMutationVariables
>;

/**
 * __useUserCardUpdateDefaultMutation__
 *
 * To run a mutation, you first call `useUserCardUpdateDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCardUpdateDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCardUpdateDefaultMutation, { data, loading, error }] = useUserCardUpdateDefaultMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserCardUpdateDefaultMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserCardUpdateDefaultMutation,
    UserCardUpdateDefaultMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserCardUpdateDefaultMutation,
    UserCardUpdateDefaultMutationVariables
  >(UserCardUpdateDefaultDocument, options);
}
export type UserCardUpdateDefaultMutationHookResult = ReturnType<
  typeof useUserCardUpdateDefaultMutation
>;
export type UserCardUpdateDefaultMutationResult =
  Apollo.MutationResult<UserCardUpdateDefaultMutation>;
export type UserCardUpdateDefaultMutationOptions = Apollo.BaseMutationOptions<
  UserCardUpdateDefaultMutation,
  UserCardUpdateDefaultMutationVariables
>;
export const UserCardDeleteDocument = gql`
  mutation UserCardDelete($user_card_id: Int!) {
    UserCardDelete(user_card_id: $user_card_id) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type UserCardDeleteMutationFn = Apollo.MutationFunction<
  UserCardDeleteMutation,
  UserCardDeleteMutationVariables
>;

/**
 * __useUserCardDeleteMutation__
 *
 * To run a mutation, you first call `useUserCardDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserCardDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userCardDeleteMutation, { data, loading, error }] = useUserCardDeleteMutation({
 *   variables: {
 *      user_card_id: // value for 'user_card_id'
 *   },
 * });
 */
export function useUserCardDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserCardDeleteMutation,
    UserCardDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserCardDeleteMutation,
    UserCardDeleteMutationVariables
  >(UserCardDeleteDocument, options);
}
export type UserCardDeleteMutationHookResult = ReturnType<
  typeof useUserCardDeleteMutation
>;
export type UserCardDeleteMutationResult =
  Apollo.MutationResult<UserCardDeleteMutation>;
export type UserCardDeleteMutationOptions = Apollo.BaseMutationOptions<
  UserCardDeleteMutation,
  UserCardDeleteMutationVariables
>;
export const UserProfileImageUploadDocument = gql`
  mutation UserProfileImageUpload($file: Upload) {
    UserProfileImageUpload(user_profile_image: $file) {
      status
      message
      data
    }
  }
`;
export type UserProfileImageUploadMutationFn = Apollo.MutationFunction<
  UserProfileImageUploadMutation,
  UserProfileImageUploadMutationVariables
>;

/**
 * __useUserProfileImageUploadMutation__
 *
 * To run a mutation, you first call `useUserProfileImageUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserProfileImageUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userProfileImageUploadMutation, { data, loading, error }] = useUserProfileImageUploadMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUserProfileImageUploadMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserProfileImageUploadMutation,
    UserProfileImageUploadMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UserProfileImageUploadMutation,
    UserProfileImageUploadMutationVariables
  >(UserProfileImageUploadDocument, options);
}
export type UserProfileImageUploadMutationHookResult = ReturnType<
  typeof useUserProfileImageUploadMutation
>;
export type UserProfileImageUploadMutationResult =
  Apollo.MutationResult<UserProfileImageUploadMutation>;
export type UserProfileImageUploadMutationOptions = Apollo.BaseMutationOptions<
  UserProfileImageUploadMutation,
  UserProfileImageUploadMutationVariables
>;
export const RecipientListingDocument = gql`
  query RecipientListing(
    $input: RecipientListingInput
    $first: Int
    $page: Int
  ) {
    RecipientListing(input: $input, first: $first, page: $page) {
      data {
        recipient_id
        bank {
          bank_id
          bank_name
        }
        recipient_category {
          recipient_category_id
          recipient_category_name
        }
        recipient_email
        recipient_mobile_number
        recipient_bank_holder_name
        recipient_bank_account_number
        total_amount
      }
      paginatorInfo {
        ...PaginatorInfo
      }
    }
  }
  ${PaginatorInfoFragmentDoc}
`;

/**
 * __useRecipientListingQuery__
 *
 * To run a query within a React component, call `useRecipientListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useRecipientListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RecipientListingQuery,
    RecipientListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RecipientListingQuery, RecipientListingQueryVariables>(
    RecipientListingDocument,
    options
  );
}
export function useRecipientListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecipientListingQuery,
    RecipientListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecipientListingQuery,
    RecipientListingQueryVariables
  >(RecipientListingDocument, options);
}
export type RecipientListingQueryHookResult = ReturnType<
  typeof useRecipientListingQuery
>;
export type RecipientListingLazyQueryHookResult = ReturnType<
  typeof useRecipientListingLazyQuery
>;
export type RecipientListingQueryResult = Apollo.QueryResult<
  RecipientListingQuery,
  RecipientListingQueryVariables
>;
export const RecipientCategoryDropdownDocument = gql`
  query RecipientCategoryDropdown {
    RecipientCategoryDropdown {
      recipient_category_id
      recipient_category_name
      is_deleted
    }
  }
`;

/**
 * __useRecipientCategoryDropdownQuery__
 *
 * To run a query within a React component, call `useRecipientCategoryDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientCategoryDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientCategoryDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecipientCategoryDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RecipientCategoryDropdownQuery,
    RecipientCategoryDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecipientCategoryDropdownQuery,
    RecipientCategoryDropdownQueryVariables
  >(RecipientCategoryDropdownDocument, options);
}
export function useRecipientCategoryDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecipientCategoryDropdownQuery,
    RecipientCategoryDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecipientCategoryDropdownQuery,
    RecipientCategoryDropdownQueryVariables
  >(RecipientCategoryDropdownDocument, options);
}
export type RecipientCategoryDropdownQueryHookResult = ReturnType<
  typeof useRecipientCategoryDropdownQuery
>;
export type RecipientCategoryDropdownLazyQueryHookResult = ReturnType<
  typeof useRecipientCategoryDropdownLazyQuery
>;
export type RecipientCategoryDropdownQueryResult = Apollo.QueryResult<
  RecipientCategoryDropdownQuery,
  RecipientCategoryDropdownQueryVariables
>;
export const RecipientListingExportDocument = gql`
  query RecipientListingExport($input: RecipientListingInput) {
    RecipientListingExport(input: $input) {
      status
      message
      data
    }
  }
`;

/**
 * __useRecipientListingExportQuery__
 *
 * To run a query within a React component, call `useRecipientListingExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecipientListingExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecipientListingExportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecipientListingExportQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RecipientListingExportQuery,
    RecipientListingExportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RecipientListingExportQuery,
    RecipientListingExportQueryVariables
  >(RecipientListingExportDocument, options);
}
export function useRecipientListingExportLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RecipientListingExportQuery,
    RecipientListingExportQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RecipientListingExportQuery,
    RecipientListingExportQueryVariables
  >(RecipientListingExportDocument, options);
}
export type RecipientListingExportQueryHookResult = ReturnType<
  typeof useRecipientListingExportQuery
>;
export type RecipientListingExportLazyQueryHookResult = ReturnType<
  typeof useRecipientListingExportLazyQuery
>;
export type RecipientListingExportQueryResult = Apollo.QueryResult<
  RecipientListingExportQuery,
  RecipientListingExportQueryVariables
>;
export const RecipientCreateDocument = gql`
  mutation RecipientCreate($input: RecipientCreateInput) {
    RecipientCreate(input: $input) {
      status
      message
      data
    }
  }
`;
export type RecipientCreateMutationFn = Apollo.MutationFunction<
  RecipientCreateMutation,
  RecipientCreateMutationVariables
>;

/**
 * __useRecipientCreateMutation__
 *
 * To run a mutation, you first call `useRecipientCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecipientCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recipientCreateMutation, { data, loading, error }] = useRecipientCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecipientCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecipientCreateMutation,
    RecipientCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecipientCreateMutation,
    RecipientCreateMutationVariables
  >(RecipientCreateDocument, options);
}
export type RecipientCreateMutationHookResult = ReturnType<
  typeof useRecipientCreateMutation
>;
export type RecipientCreateMutationResult =
  Apollo.MutationResult<RecipientCreateMutation>;
export type RecipientCreateMutationOptions = Apollo.BaseMutationOptions<
  RecipientCreateMutation,
  RecipientCreateMutationVariables
>;
export const RecipientDeleteDocument = gql`
  mutation RecipientDelete($recipient_id: Int!) {
    RecipientDelete(recipient_id: $recipient_id) {
      status
      message
      data
    }
  }
`;
export type RecipientDeleteMutationFn = Apollo.MutationFunction<
  RecipientDeleteMutation,
  RecipientDeleteMutationVariables
>;

/**
 * __useRecipientDeleteMutation__
 *
 * To run a mutation, you first call `useRecipientDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecipientDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recipientDeleteMutation, { data, loading, error }] = useRecipientDeleteMutation({
 *   variables: {
 *      recipient_id: // value for 'recipient_id'
 *   },
 * });
 */
export function useRecipientDeleteMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RecipientDeleteMutation,
    RecipientDeleteMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RecipientDeleteMutation,
    RecipientDeleteMutationVariables
  >(RecipientDeleteDocument, options);
}
export type RecipientDeleteMutationHookResult = ReturnType<
  typeof useRecipientDeleteMutation
>;
export type RecipientDeleteMutationResult =
  Apollo.MutationResult<RecipientDeleteMutation>;
export type RecipientDeleteMutationOptions = Apollo.BaseMutationOptions<
  RecipientDeleteMutation,
  RecipientDeleteMutationVariables
>;
export const BankDropdownDocument = gql`
  query BankDropdown {
    BankDropdown {
      bank_id
      bank_name
      bank_logo {
        thumb
      }
      is_deleted
    }
  }
`;

/**
 * __useBankDropdownQuery__
 *
 * To run a query within a React component, call `useBankDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useBankDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BankDropdownQuery,
    BankDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BankDropdownQuery, BankDropdownQueryVariables>(
    BankDropdownDocument,
    options
  );
}
export function useBankDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BankDropdownQuery,
    BankDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BankDropdownQuery, BankDropdownQueryVariables>(
    BankDropdownDocument,
    options
  );
}
export type BankDropdownQueryHookResult = ReturnType<
  typeof useBankDropdownQuery
>;
export type BankDropdownLazyQueryHookResult = ReturnType<
  typeof useBankDropdownLazyQuery
>;
export type BankDropdownQueryResult = Apollo.QueryResult<
  BankDropdownQuery,
  BankDropdownQueryVariables
>;
export const BankNameSearchDocument = gql`
  query BankNameSearch($input: String!) {
    BankNameSearch(bank_name: $input) {
      bank_id
      bank_name
    }
  }
`;

/**
 * __useBankNameSearchQuery__
 *
 * To run a query within a React component, call `useBankNameSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankNameSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankNameSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBankNameSearchQuery(
  baseOptions: Apollo.QueryHookOptions<
    BankNameSearchQuery,
    BankNameSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<BankNameSearchQuery, BankNameSearchQueryVariables>(
    BankNameSearchDocument,
    options
  );
}
export function useBankNameSearchLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BankNameSearchQuery,
    BankNameSearchQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<BankNameSearchQuery, BankNameSearchQueryVariables>(
    BankNameSearchDocument,
    options
  );
}
export type BankNameSearchQueryHookResult = ReturnType<
  typeof useBankNameSearchQuery
>;
export type BankNameSearchLazyQueryHookResult = ReturnType<
  typeof useBankNameSearchLazyQuery
>;
export type BankNameSearchQueryResult = Apollo.QueryResult<
  BankNameSearchQuery,
  BankNameSearchQueryVariables
>;
export const BusinessTypeDropdownDocument = gql`
  query BusinessTypeDropdown {
    BusinessTypeDropdown {
      business_type_id
      business_type_name
      business_type_status
      is_deleted
    }
  }
`;

/**
 * __useBusinessTypeDropdownQuery__
 *
 * To run a query within a React component, call `useBusinessTypeDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessTypeDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessTypeDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessTypeDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BusinessTypeDropdownQuery,
    BusinessTypeDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BusinessTypeDropdownQuery,
    BusinessTypeDropdownQueryVariables
  >(BusinessTypeDropdownDocument, options);
}
export function useBusinessTypeDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BusinessTypeDropdownQuery,
    BusinessTypeDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BusinessTypeDropdownQuery,
    BusinessTypeDropdownQueryVariables
  >(BusinessTypeDropdownDocument, options);
}
export type BusinessTypeDropdownQueryHookResult = ReturnType<
  typeof useBusinessTypeDropdownQuery
>;
export type BusinessTypeDropdownLazyQueryHookResult = ReturnType<
  typeof useBusinessTypeDropdownLazyQuery
>;
export type BusinessTypeDropdownQueryResult = Apollo.QueryResult<
  BusinessTypeDropdownQuery,
  BusinessTypeDropdownQueryVariables
>;
export const BusinessYearDropdownDocument = gql`
  query BusinessYearDropdown {
    BusinessYearDropdown {
      year_of_business_id
      year_of_business_name
      year_of_business_status
      is_deleted
    }
  }
`;

/**
 * __useBusinessYearDropdownQuery__
 *
 * To run a query within a React component, call `useBusinessYearDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useBusinessYearDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBusinessYearDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useBusinessYearDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BusinessYearDropdownQuery,
    BusinessYearDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    BusinessYearDropdownQuery,
    BusinessYearDropdownQueryVariables
  >(BusinessYearDropdownDocument, options);
}
export function useBusinessYearDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BusinessYearDropdownQuery,
    BusinessYearDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    BusinessYearDropdownQuery,
    BusinessYearDropdownQueryVariables
  >(BusinessYearDropdownDocument, options);
}
export type BusinessYearDropdownQueryHookResult = ReturnType<
  typeof useBusinessYearDropdownQuery
>;
export type BusinessYearDropdownLazyQueryHookResult = ReturnType<
  typeof useBusinessYearDropdownLazyQuery
>;
export type BusinessYearDropdownQueryResult = Apollo.QueryResult<
  BusinessYearDropdownQuery,
  BusinessYearDropdownQueryVariables
>;
export const RejectReasonDropdownDocument = gql`
  query RejectReasonDropdown($input: RejectReasonType) {
    RejectReasonDropdown(reject_reason_type: $input) {
      reject_reason_id
      reject_reason_name
      reject_reason_description
      reject_reason_type
      is_deleted
    }
  }
`;

/**
 * __useRejectReasonDropdownQuery__
 *
 * To run a query within a React component, call `useRejectReasonDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useRejectReasonDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRejectReasonDropdownQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectReasonDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    RejectReasonDropdownQuery,
    RejectReasonDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    RejectReasonDropdownQuery,
    RejectReasonDropdownQueryVariables
  >(RejectReasonDropdownDocument, options);
}
export function useRejectReasonDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RejectReasonDropdownQuery,
    RejectReasonDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RejectReasonDropdownQuery,
    RejectReasonDropdownQueryVariables
  >(RejectReasonDropdownDocument, options);
}
export type RejectReasonDropdownQueryHookResult = ReturnType<
  typeof useRejectReasonDropdownQuery
>;
export type RejectReasonDropdownLazyQueryHookResult = ReturnType<
  typeof useRejectReasonDropdownLazyQuery
>;
export type RejectReasonDropdownQueryResult = Apollo.QueryResult<
  RejectReasonDropdownQuery,
  RejectReasonDropdownQueryVariables
>;
export const AnnualRevenueDropdownDocument = gql`
  query AnnualRevenueDropdown {
    AnnualRevenueDropdown {
      setting_annual_revenue_id
      setting_annual_revenue_name
    }
  }
`;

/**
 * __useAnnualRevenueDropdownQuery__
 *
 * To run a query within a React component, call `useAnnualRevenueDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnnualRevenueDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnnualRevenueDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnnualRevenueDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AnnualRevenueDropdownQuery,
    AnnualRevenueDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    AnnualRevenueDropdownQuery,
    AnnualRevenueDropdownQueryVariables
  >(AnnualRevenueDropdownDocument, options);
}
export function useAnnualRevenueDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AnnualRevenueDropdownQuery,
    AnnualRevenueDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    AnnualRevenueDropdownQuery,
    AnnualRevenueDropdownQueryVariables
  >(AnnualRevenueDropdownDocument, options);
}
export type AnnualRevenueDropdownQueryHookResult = ReturnType<
  typeof useAnnualRevenueDropdownQuery
>;
export type AnnualRevenueDropdownLazyQueryHookResult = ReturnType<
  typeof useAnnualRevenueDropdownLazyQuery
>;
export type AnnualRevenueDropdownQueryResult = Apollo.QueryResult<
  AnnualRevenueDropdownQuery,
  AnnualRevenueDropdownQueryVariables
>;
export const CompanySizeDropdownDocument = gql`
  query CompanySizeDropdown {
    CompanySizeDropdown {
      setting_company_size_id
      setting_company_size_name
    }
  }
`;

/**
 * __useCompanySizeDropdownQuery__
 *
 * To run a query within a React component, call `useCompanySizeDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySizeDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySizeDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanySizeDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CompanySizeDropdownQuery,
    CompanySizeDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CompanySizeDropdownQuery,
    CompanySizeDropdownQueryVariables
  >(CompanySizeDropdownDocument, options);
}
export function useCompanySizeDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CompanySizeDropdownQuery,
    CompanySizeDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CompanySizeDropdownQuery,
    CompanySizeDropdownQueryVariables
  >(CompanySizeDropdownDocument, options);
}
export type CompanySizeDropdownQueryHookResult = ReturnType<
  typeof useCompanySizeDropdownQuery
>;
export type CompanySizeDropdownLazyQueryHookResult = ReturnType<
  typeof useCompanySizeDropdownLazyQuery
>;
export type CompanySizeDropdownQueryResult = Apollo.QueryResult<
  CompanySizeDropdownQuery,
  CompanySizeDropdownQueryVariables
>;
export const MerchantCustomerListingDocument = gql`
  query MerchantCustomerListing(
    $input: MerchantCustomerListingInput
    $first: Int
    $page: Int
  ) {
    MerchantCustomerListing(input: $input, first: $first, page: $page) {
      data {
        ...MerchantCustomer
      }
      paginatorInfo {
        ...PaginatorInfo
      }
    }
  }
  ${MerchantCustomerFragmentDoc}
  ${PaginatorInfoFragmentDoc}
`;

/**
 * __useMerchantCustomerListingQuery__
 *
 * To run a query within a React component, call `useMerchantCustomerListingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCustomerListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCustomerListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useMerchantCustomerListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MerchantCustomerListingQuery,
    MerchantCustomerListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MerchantCustomerListingQuery,
    MerchantCustomerListingQueryVariables
  >(MerchantCustomerListingDocument, options);
}
export function useMerchantCustomerListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MerchantCustomerListingQuery,
    MerchantCustomerListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MerchantCustomerListingQuery,
    MerchantCustomerListingQueryVariables
  >(MerchantCustomerListingDocument, options);
}
export type MerchantCustomerListingQueryHookResult = ReturnType<
  typeof useMerchantCustomerListingQuery
>;
export type MerchantCustomerListingLazyQueryHookResult = ReturnType<
  typeof useMerchantCustomerListingLazyQuery
>;
export type MerchantCustomerListingQueryResult = Apollo.QueryResult<
  MerchantCustomerListingQuery,
  MerchantCustomerListingQueryVariables
>;
export const MerchantCustomerDropdownDocument = gql`
  query MerchantCustomerDropdown {
    MerchantCustomerDropdown {
      merchant_customer_id
      merchant_customer_name
      merchant_customer_company_name
      merchant_customer_registration_number
    }
  }
`;

/**
 * __useMerchantCustomerDropdownQuery__
 *
 * To run a query within a React component, call `useMerchantCustomerDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCustomerDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCustomerDropdownQuery({
 *   variables: {
 *   },
 * });
 */
export function useMerchantCustomerDropdownQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MerchantCustomerDropdownQuery,
    MerchantCustomerDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MerchantCustomerDropdownQuery,
    MerchantCustomerDropdownQueryVariables
  >(MerchantCustomerDropdownDocument, options);
}
export function useMerchantCustomerDropdownLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MerchantCustomerDropdownQuery,
    MerchantCustomerDropdownQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MerchantCustomerDropdownQuery,
    MerchantCustomerDropdownQueryVariables
  >(MerchantCustomerDropdownDocument, options);
}
export type MerchantCustomerDropdownQueryHookResult = ReturnType<
  typeof useMerchantCustomerDropdownQuery
>;
export type MerchantCustomerDropdownLazyQueryHookResult = ReturnType<
  typeof useMerchantCustomerDropdownLazyQuery
>;
export type MerchantCustomerDropdownQueryResult = Apollo.QueryResult<
  MerchantCustomerDropdownQuery,
  MerchantCustomerDropdownQueryVariables
>;
export const MerchantCustomerDetailDocument = gql`
  query MerchantCustomerDetail($merchant_customer_id: Int) {
    MerchantCustomerDetail(merchant_customer_id: $merchant_customer_id) {
      ...MerchantCustomer
    }
  }
  ${MerchantCustomerFragmentDoc}
`;

/**
 * __useMerchantCustomerDetailQuery__
 *
 * To run a query within a React component, call `useMerchantCustomerDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCustomerDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCustomerDetailQuery({
 *   variables: {
 *      merchant_customer_id: // value for 'merchant_customer_id'
 *   },
 * });
 */
export function useMerchantCustomerDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MerchantCustomerDetailQuery,
    MerchantCustomerDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MerchantCustomerDetailQuery,
    MerchantCustomerDetailQueryVariables
  >(MerchantCustomerDetailDocument, options);
}
export function useMerchantCustomerDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MerchantCustomerDetailQuery,
    MerchantCustomerDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MerchantCustomerDetailQuery,
    MerchantCustomerDetailQueryVariables
  >(MerchantCustomerDetailDocument, options);
}
export type MerchantCustomerDetailQueryHookResult = ReturnType<
  typeof useMerchantCustomerDetailQuery
>;
export type MerchantCustomerDetailLazyQueryHookResult = ReturnType<
  typeof useMerchantCustomerDetailLazyQuery
>;
export type MerchantCustomerDetailQueryResult = Apollo.QueryResult<
  MerchantCustomerDetailQuery,
  MerchantCustomerDetailQueryVariables
>;
export const MerchantCustomerStatusCountDocument = gql`
  query MerchantCustomerStatusCount($input: MerchantCustomerListingInput) {
    MerchantCustomerStatusCount(input: $input) {
      merchant_customer_status
      status_count
    }
  }
`;

/**
 * __useMerchantCustomerStatusCountQuery__
 *
 * To run a query within a React component, call `useMerchantCustomerStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMerchantCustomerStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMerchantCustomerStatusCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMerchantCustomerStatusCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    MerchantCustomerStatusCountQuery,
    MerchantCustomerStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    MerchantCustomerStatusCountQuery,
    MerchantCustomerStatusCountQueryVariables
  >(MerchantCustomerStatusCountDocument, options);
}
export function useMerchantCustomerStatusCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    MerchantCustomerStatusCountQuery,
    MerchantCustomerStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    MerchantCustomerStatusCountQuery,
    MerchantCustomerStatusCountQueryVariables
  >(MerchantCustomerStatusCountDocument, options);
}
export type MerchantCustomerStatusCountQueryHookResult = ReturnType<
  typeof useMerchantCustomerStatusCountQuery
>;
export type MerchantCustomerStatusCountLazyQueryHookResult = ReturnType<
  typeof useMerchantCustomerStatusCountLazyQuery
>;
export type MerchantCustomerStatusCountQueryResult = Apollo.QueryResult<
  MerchantCustomerStatusCountQuery,
  MerchantCustomerStatusCountQueryVariables
>;
export const MerchantCustomerCreateDocument = gql`
  mutation MerchantCustomerCreate($input: MerchantCustomerCreateInput) {
    MerchantCustomerCreate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type MerchantCustomerCreateMutationFn = Apollo.MutationFunction<
  MerchantCustomerCreateMutation,
  MerchantCustomerCreateMutationVariables
>;

/**
 * __useMerchantCustomerCreateMutation__
 *
 * To run a mutation, you first call `useMerchantCustomerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantCustomerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantCustomerCreateMutation, { data, loading, error }] = useMerchantCustomerCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMerchantCustomerCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MerchantCustomerCreateMutation,
    MerchantCustomerCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MerchantCustomerCreateMutation,
    MerchantCustomerCreateMutationVariables
  >(MerchantCustomerCreateDocument, options);
}
export type MerchantCustomerCreateMutationHookResult = ReturnType<
  typeof useMerchantCustomerCreateMutation
>;
export type MerchantCustomerCreateMutationResult =
  Apollo.MutationResult<MerchantCustomerCreateMutation>;
export type MerchantCustomerCreateMutationOptions = Apollo.BaseMutationOptions<
  MerchantCustomerCreateMutation,
  MerchantCustomerCreateMutationVariables
>;
export const MerchantCustomerUpdateDocument = gql`
  mutation MerchantCustomerUpdate($input: MerchantCustomerUpdateInput) {
    MerchantCustomerUpdate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type MerchantCustomerUpdateMutationFn = Apollo.MutationFunction<
  MerchantCustomerUpdateMutation,
  MerchantCustomerUpdateMutationVariables
>;

/**
 * __useMerchantCustomerUpdateMutation__
 *
 * To run a mutation, you first call `useMerchantCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantCustomerUpdateMutation, { data, loading, error }] = useMerchantCustomerUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMerchantCustomerUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MerchantCustomerUpdateMutation,
    MerchantCustomerUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MerchantCustomerUpdateMutation,
    MerchantCustomerUpdateMutationVariables
  >(MerchantCustomerUpdateDocument, options);
}
export type MerchantCustomerUpdateMutationHookResult = ReturnType<
  typeof useMerchantCustomerUpdateMutation
>;
export type MerchantCustomerUpdateMutationResult =
  Apollo.MutationResult<MerchantCustomerUpdateMutation>;
export type MerchantCustomerUpdateMutationOptions = Apollo.BaseMutationOptions<
  MerchantCustomerUpdateMutation,
  MerchantCustomerUpdateMutationVariables
>;
export const MerchantCustomerStatusUpdateDocument = gql`
  mutation MerchantCustomerStatusUpdate(
    $input: MerchantCustomerStatusUpdateInput
  ) {
    MerchantCustomerStatusUpdate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type MerchantCustomerStatusUpdateMutationFn = Apollo.MutationFunction<
  MerchantCustomerStatusUpdateMutation,
  MerchantCustomerStatusUpdateMutationVariables
>;

/**
 * __useMerchantCustomerStatusUpdateMutation__
 *
 * To run a mutation, you first call `useMerchantCustomerStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMerchantCustomerStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [merchantCustomerStatusUpdateMutation, { data, loading, error }] = useMerchantCustomerStatusUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMerchantCustomerStatusUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MerchantCustomerStatusUpdateMutation,
    MerchantCustomerStatusUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MerchantCustomerStatusUpdateMutation,
    MerchantCustomerStatusUpdateMutationVariables
  >(MerchantCustomerStatusUpdateDocument, options);
}
export type MerchantCustomerStatusUpdateMutationHookResult = ReturnType<
  typeof useMerchantCustomerStatusUpdateMutation
>;
export type MerchantCustomerStatusUpdateMutationResult =
  Apollo.MutationResult<MerchantCustomerStatusUpdateMutation>;
export type MerchantCustomerStatusUpdateMutationOptions =
  Apollo.BaseMutationOptions<
    MerchantCustomerStatusUpdateMutation,
    MerchantCustomerStatusUpdateMutationVariables
  >;
export const PaymentLinkListingDocument = gql`
  query PaymentLinkListing(
    $input: PaymentLinkListingInput
    $first: Int
    $page: Int
  ) {
    PaymentLinkListing(input: $input, first: $first, page: $page) {
      data {
        ...PaymentLink
      }
      paginatorInfo {
        ...PaginatorInfo
      }
    }
  }
  ${PaymentLinkFragmentDoc}
  ${PaginatorInfoFragmentDoc}
`;

/**
 * __usePaymentLinkListingQuery__
 *
 * To run a query within a React component, call `usePaymentLinkListingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLinkListingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLinkListingQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePaymentLinkListingQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentLinkListingQuery,
    PaymentLinkListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentLinkListingQuery,
    PaymentLinkListingQueryVariables
  >(PaymentLinkListingDocument, options);
}
export function usePaymentLinkListingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentLinkListingQuery,
    PaymentLinkListingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentLinkListingQuery,
    PaymentLinkListingQueryVariables
  >(PaymentLinkListingDocument, options);
}
export type PaymentLinkListingQueryHookResult = ReturnType<
  typeof usePaymentLinkListingQuery
>;
export type PaymentLinkListingLazyQueryHookResult = ReturnType<
  typeof usePaymentLinkListingLazyQuery
>;
export type PaymentLinkListingQueryResult = Apollo.QueryResult<
  PaymentLinkListingQuery,
  PaymentLinkListingQueryVariables
>;
export const PaymentLinkMakeDocument = gql`
  query PaymentLinkMake($payment_id: Int) {
    PaymentLinkMake(payment_id: $payment_id) {
      payment_url
      payment_number
    }
  }
`;

/**
 * __usePaymentLinkMakeQuery__
 *
 * To run a query within a React component, call `usePaymentLinkMakeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLinkMakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLinkMakeQuery({
 *   variables: {
 *      payment_id: // value for 'payment_id'
 *   },
 * });
 */
export function usePaymentLinkMakeQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentLinkMakeQuery,
    PaymentLinkMakeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PaymentLinkMakeQuery, PaymentLinkMakeQueryVariables>(
    PaymentLinkMakeDocument,
    options
  );
}
export function usePaymentLinkMakeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentLinkMakeQuery,
    PaymentLinkMakeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentLinkMakeQuery,
    PaymentLinkMakeQueryVariables
  >(PaymentLinkMakeDocument, options);
}
export type PaymentLinkMakeQueryHookResult = ReturnType<
  typeof usePaymentLinkMakeQuery
>;
export type PaymentLinkMakeLazyQueryHookResult = ReturnType<
  typeof usePaymentLinkMakeLazyQuery
>;
export type PaymentLinkMakeQueryResult = Apollo.QueryResult<
  PaymentLinkMakeQuery,
  PaymentLinkMakeQueryVariables
>;
export const PaymentLinkDetailDocument = gql`
  query PaymentLinkDetail($payment_id: Int) {
    PaymentLinkDetail(payment_id: $payment_id) {
      ...PaymentLink
    }
  }
  ${PaymentLinkFragmentDoc}
`;

/**
 * __usePaymentLinkDetailQuery__
 *
 * To run a query within a React component, call `usePaymentLinkDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLinkDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLinkDetailQuery({
 *   variables: {
 *      payment_id: // value for 'payment_id'
 *   },
 * });
 */
export function usePaymentLinkDetailQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentLinkDetailQuery,
    PaymentLinkDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentLinkDetailQuery,
    PaymentLinkDetailQueryVariables
  >(PaymentLinkDetailDocument, options);
}
export function usePaymentLinkDetailLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentLinkDetailQuery,
    PaymentLinkDetailQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentLinkDetailQuery,
    PaymentLinkDetailQueryVariables
  >(PaymentLinkDetailDocument, options);
}
export type PaymentLinkDetailQueryHookResult = ReturnType<
  typeof usePaymentLinkDetailQuery
>;
export type PaymentLinkDetailLazyQueryHookResult = ReturnType<
  typeof usePaymentLinkDetailLazyQuery
>;
export type PaymentLinkDetailQueryResult = Apollo.QueryResult<
  PaymentLinkDetailQuery,
  PaymentLinkDetailQueryVariables
>;
export const PaymentLinkStatusCountDocument = gql`
  query PaymentLinkStatusCount($input: PaymentLinkListingInput) {
    PaymentLinkStatusCount(input: $input) {
      payment_status
      count
    }
  }
`;

/**
 * __usePaymentLinkStatusCountQuery__
 *
 * To run a query within a React component, call `usePaymentLinkStatusCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLinkStatusCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLinkStatusCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentLinkStatusCountQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentLinkStatusCountQuery,
    PaymentLinkStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentLinkStatusCountQuery,
    PaymentLinkStatusCountQueryVariables
  >(PaymentLinkStatusCountDocument, options);
}
export function usePaymentLinkStatusCountLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentLinkStatusCountQuery,
    PaymentLinkStatusCountQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentLinkStatusCountQuery,
    PaymentLinkStatusCountQueryVariables
  >(PaymentLinkStatusCountDocument, options);
}
export type PaymentLinkStatusCountQueryHookResult = ReturnType<
  typeof usePaymentLinkStatusCountQuery
>;
export type PaymentLinkStatusCountLazyQueryHookResult = ReturnType<
  typeof usePaymentLinkStatusCountLazyQuery
>;
export type PaymentLinkStatusCountQueryResult = Apollo.QueryResult<
  PaymentLinkStatusCountQuery,
  PaymentLinkStatusCountQueryVariables
>;
export const PaymentLinkReferenceDocument = gql`
  query PaymentLinkReference($payment_referer_code: String) {
    PaymentLinkReference(payment_referer_code: $payment_referer_code) {
      ...PaymentLink
    }
  }
  ${PaymentLinkFragmentDoc}
`;

/**
 * __usePaymentLinkReferenceQuery__
 *
 * To run a query within a React component, call `usePaymentLinkReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentLinkReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentLinkReferenceQuery({
 *   variables: {
 *      payment_referer_code: // value for 'payment_referer_code'
 *   },
 * });
 */
export function usePaymentLinkReferenceQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PaymentLinkReferenceQuery,
    PaymentLinkReferenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PaymentLinkReferenceQuery,
    PaymentLinkReferenceQueryVariables
  >(PaymentLinkReferenceDocument, options);
}
export function usePaymentLinkReferenceLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PaymentLinkReferenceQuery,
    PaymentLinkReferenceQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PaymentLinkReferenceQuery,
    PaymentLinkReferenceQueryVariables
  >(PaymentLinkReferenceDocument, options);
}
export type PaymentLinkReferenceQueryHookResult = ReturnType<
  typeof usePaymentLinkReferenceQuery
>;
export type PaymentLinkReferenceLazyQueryHookResult = ReturnType<
  typeof usePaymentLinkReferenceLazyQuery
>;
export type PaymentLinkReferenceQueryResult = Apollo.QueryResult<
  PaymentLinkReferenceQuery,
  PaymentLinkReferenceQueryVariables
>;
export const PaymentLinkCreateDocument = gql`
  mutation PaymentLinkCreate($input: PaymentLinkCreateInput) {
    PaymentLinkCreate(input: $input) {
      ...SuccessResponse
    }
  }
  ${SuccessResponseFragmentDoc}
`;
export type PaymentLinkCreateMutationFn = Apollo.MutationFunction<
  PaymentLinkCreateMutation,
  PaymentLinkCreateMutationVariables
>;

/**
 * __usePaymentLinkCreateMutation__
 *
 * To run a mutation, you first call `usePaymentLinkCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentLinkCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentLinkCreateMutation, { data, loading, error }] = usePaymentLinkCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentLinkCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PaymentLinkCreateMutation,
    PaymentLinkCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PaymentLinkCreateMutation,
    PaymentLinkCreateMutationVariables
  >(PaymentLinkCreateDocument, options);
}
export type PaymentLinkCreateMutationHookResult = ReturnType<
  typeof usePaymentLinkCreateMutation
>;
export type PaymentLinkCreateMutationResult =
  Apollo.MutationResult<PaymentLinkCreateMutation>;
export type PaymentLinkCreateMutationOptions = Apollo.BaseMutationOptions<
  PaymentLinkCreateMutation,
  PaymentLinkCreateMutationVariables
>;
export const PaymentLinkCalculateDocument = gql`
  mutation PaymentLinkCalculate($input: PaymentLinkCalculateInput) {
    PaymentLinkCalculate(input: $input) {
      ...PaymentCalculation
    }
  }
  ${PaymentCalculationFragmentDoc}
`;
export type PaymentLinkCalculateMutationFn = Apollo.MutationFunction<
  PaymentLinkCalculateMutation,
  PaymentLinkCalculateMutationVariables
>;

/**
 * __usePaymentLinkCalculateMutation__
 *
 * To run a mutation, you first call `usePaymentLinkCalculateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentLinkCalculateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentLinkCalculateMutation, { data, loading, error }] = usePaymentLinkCalculateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePaymentLinkCalculateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PaymentLinkCalculateMutation,
    PaymentLinkCalculateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    PaymentLinkCalculateMutation,
    PaymentLinkCalculateMutationVariables
  >(PaymentLinkCalculateDocument, options);
}
export type PaymentLinkCalculateMutationHookResult = ReturnType<
  typeof usePaymentLinkCalculateMutation
>;
export type PaymentLinkCalculateMutationResult =
  Apollo.MutationResult<PaymentLinkCalculateMutation>;
export type PaymentLinkCalculateMutationOptions = Apollo.BaseMutationOptions<
  PaymentLinkCalculateMutation,
  PaymentLinkCalculateMutationVariables
>;
